<template>
  <div class="page-dashboard">
    <div class="plan-list" v-if="selectedLevel != 'load'">
      <el-row>
        <el-col :span="21" :offset="3">
          <el-row>
            <el-col v-for="(item, index) in planTimeList" :key="index" :span="1" class="time-col"
              ><span class="time">{{ item }}</span></el-col
            >
            <span class="special-time">24:00</span>
          </el-row>
        </el-col>
      </el-row>
      <el-row
        v-for="(systemPlan, systemIndex) in systemPlanList"
        :key="systemIndex"
        class="flex flex-cross-center system-one"
      >
        <el-col :span="3">
          <div class="system-name">{{ systemPlan.systemName }}</div>
        </el-col>
        <el-col :span="21" class="pr">
          <div
            class="current-time-line-box"
            :style="{ left: currentTimeLineLeft() + '%' }"
          >
            <i class="current-time-line tac"></i>
            <span class="tac current-time-text" v-show="systemIndex == 0">{{
              realTime.slice(0, 5)
            }}</span>
          </div>
          <el-row v-for="(plan, systemPlanOneIndex) in systemPlan.plansInfoList" :key="systemPlanOneIndex">
            <el-col
              v-for="(item, index) in plan.infoList"
              :key="index"
              :span="item.splitNum"
              ><el-tooltip
                class="item"
                effect="dark"
                :content="handleEventDetailShow(item, systemPlanOneIndex, systemPlan)"
                placement="top"
                ><div
                  v-if="isFutureTime()"
                  class="grid-content future-time"
                  :class="planModeClass[item.modeType]"
                ></div>
                <div
                  v-else
                  class="grid-content"
                  :class="planModeClass[item.modeType]"
                ></div></el-tooltip
            ></el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div v-if="dateMode.includes('10')">
      <!-- 站点/系统数据 -->
      <el-row
        class="info-list"
        v-if="selectedLevel == 'site' || selectedLevel == 'system'"
      >
        <el-col :span="4">
          <div class="info-one">
            <p class="param-name">{{ $t("m.totalChargingRevenue") }}</p>
            <p class="param-value">
              {{
                getMoneyUnit() +
                  " " +
                  handleDataEmptyShow(topParamInfoData.chargingRevenue)
              }}
            </p>
          </div>
        </el-col>
        <el-col :span="8" :offset="1">
          <div class="info-one total-charge-box">
            <p class="param-name">{{ $t("m.totalCharge") }}（kWh）</p>
            <div class="flex h-100" v-if="topParamInfoData.charge.total">
              <div class="total-charge-chart" ref="total-charge-chart"></div>
              <div class="charge-from-list">
                <div
                  class="charge-one flex flex-main-justify"
                  v-for="(item, index) in topParamInfoData.charge.list"
                  :key="index"
                >
                  <div class="flex flex-cross-center">
                    <span class="charge-one-cycle" :class="item.type"></span>
                    <span class="charge-one-name">{{ item.name }} : </span>
                  </div>
                  <span class="charge-one-value">{{ item.value }}</span>
                </div>
              </div>
            </div>
            <div v-else class="empty-box">0</div>
          </div>
        </el-col>
        <el-col :span="5" :offset="1">
          <div class="info-one">
            <p class="param-name">{{ $t("m.totalAvailableCharge") }} (kWh)</p>
            <p class="param-value">
              {{ handleDataEmptyShow(topParamInfoData.availableCharge) }}
            </p>
          </div>
        </el-col>
        <el-col :span="4" :offset="1">
          <div class="info-one">
            <p class="param-name">{{ $t("m.utilisationRate") }}</p>
            <p class="param-value">
              {{ handleDataEmptyShow(topParamInfoData.utilizationRate) }}%
            </p>
          </div>
        </el-col>
      </el-row>
      <!-- 储能数据 -->
      <el-row class="info-list" v-if="selectedLevel == 'asset-bess'">
        <el-col :span="11">
          <div class="info-one">
            <p class="param-name">{{ $t("m.totalCharge") }}</p>
            <p class="param-value">
              {{
                topInfoData.BESS_CHARGE && topInfoData.BESS_CHARGE.sum
                  ? handleDataEmptyShow(topInfoData.BESS_CHARGE.sum) +
                    " " +
                    "kWh"
                  : ""
              }}
            </p>
          </div>
        </el-col>
        <el-col :span="11" :offset="2">
          <div class="info-one">
            <p class="param-name">{{ $t("m.totalDischarge") }}</p>
            <p class="param-value">
              {{
                topInfoData.BESS_DISCHARGE && topInfoData.BESS_DISCHARGE.sum
                  ? handleDataEmptyShow(topInfoData.BESS_DISCHARGE.sum) +
                    " " +
                    "kWh"
                  : ""
              }}
            </p>
          </div>
        </el-col>
      </el-row>
      <!-- 光伏数据 -->
      <el-row class="info-list" v-if="selectedLevel == 'asset-pv'">
        <el-col :span="24">
          <div class="info-one">
            <p class="param-name">{{ $t("m.totalPVGenerate") }}</p>
            <p class="param-value">
              {{
                topInfoData.SOLAR && topInfoData.SOLAR.sum
                  ? handleDataEmptyShow(topInfoData.SOLAR.sum) + " " + "kWh"
                  : 0
              }}
            </p>
          </div>
        </el-col>
      </el-row>
      <!-- 负荷数据 -->
      <el-row class="info-list" v-if="selectedLevel == 'load'">
        <el-col :span="4">
          <div class="info-one">
            <p class="param-name">{{ $t("m.totalAppliancesElectricity") }}</p>
            <p class="param-value">
              {{
                topInfoData.LOAD && topInfoData.LOAD.sum
                  ? handleDataEmptyShow(topInfoData.LOAD.sum) + " " + "kWh"
                  : ""
              }}
            </p>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- live monitor 只在今天且（站点页面时或者系统页面当前模式为超充时）显示 -->
    <div
      class="live-monitor public-box"
      v-if="
        !isHistory() &&
          ((selectedLevel == 'site' || selectedLevel == 'system') &&
            currentMode.includes('10'))
      "
    >
      <div class="live-monitor-header public-header flex flex-main-justify">
        <span class="header-title">{{ $t("m.liveMonitor") + " (kW)" }}</span>
        <div class="charging-status-box flex">
          <span>{{ $t("m.chargingStatus") }}: </span>
          <div class="status-list flex">
            <div class="status-one">
              <i class="status-cycle free"></i>
              <span>{{ $t("m.free") }}</span>
            </div>
            <div class="status-one">
              <i class="status-cycle reserved"></i>
              <span>{{ $t("m.reserved") }}</span>
            </div>
            <div class="status-one">
              <i class="status-cycle charging"></i>
              <span>{{ $t("m.charging") }}</span>
            </div>
            <div class="status-one">
              <i class="status-cycle offline"></i>
              <span>{{ $t("m.offLine") }}</span>
            </div>
            <div class="status-one">
              <i class="status-cycle faulted"></i>
              <span>{{ $t("m.faulted") }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="live-monitor-content">
        <!-- grid -->
        <el-row class="grid">
          <el-col :span="4" class="param-name">{{ $t("m.Grid") }}</el-col>
          <el-col
            :span="20 / systemList.length"
            v-for="(item, index) in systemList"
            :key="index"
            class="param-value"
            >{{ systemGridObj[item.spSystemId] }}</el-col
          >
        </el-row>
        <!-- site load -->
        <el-row class="site-load">
          <el-col :span="4" class="param-name">{{ $t("m.siteLoad") }}</el-col>
          <el-col
            :span="20 / systemList.length"
            v-for="(item, index) in systemList"
            :key="index"
            class="param-value"
            >{{ systemLoadObj[item.spSystemId] }}</el-col
          >
        </el-row>
        <!-- ergy system -->
        <el-row class="site-load">
          <el-col :span="4" class="param-name">{{ $t("m.ergySystem") }}</el-col>
          <el-col
            :span="20 / systemList.length"
            v-for="(item, index) in systemList"
            :key="index"
            class="param-value"
            >{{ systemSystemObj[item.spSystemId] }}</el-col
          >
        </el-row>
        <!-- solar -->
        <el-row class="site-load">
          <el-col :span="4" class="param-name">{{ $t("m.solar") }}</el-col>
          <el-col
            :span="20 / systemList.length"
            v-for="(item, index) in systemList"
            :key="index"
            class="param-value"
            >{{ systemSolarObj[item.spSystemId] }}</el-col
          >
        </el-row>
        <!-- battery -->
        <el-row class="site-load" v-if="haveBESS()">
          <el-col :span="4" class="param-name">{{ $t("m.assetES") }}</el-col>
          <el-col
            :span="20 / systemList.length"
            v-for="(item, index) in systemList"
            :key="index"
            class="param-value"
            >{{ systemBatteryObj[item.spSystemId] }}</el-col
          >
        </el-row>
        <!-- charging -->
        <el-row class="site-load" v-if="systemList.length">
          <el-col :span="4" class="param-name">{{ $t("m.charger") }}</el-col>
          <el-col
            :span="parseInt(20 / systemList.length)"
            v-for="(system, systemIndex) in systemList"
            :key="systemIndex"
            class="system-one"
          >
            <el-col
              :span="
                parseInt(24 / systemChargeGunListObj[system.spSystemId].length)
              "
              v-for="(item, index) in systemChargeGunListObj[system.spSystemId]"
              :key="index"
              class="param-value"
              :class="gunStatusTextObj[gunStatusObj[item.spChargerGunId]]"
            >
              {{ item.value }}
            </el-col>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 调频模式(Ancillary Service) live monitor -->
    <div
      class="ancillary-service-live-monitor public-box"
      v-if="
        currentMode.includes('20') &&
          ['site', 'system'].includes(selectedLevel) &&
          isToday()
      "
    >
      <div class="public-header">
        <span
          v-for="item in ancillaryServiceSystemList"
          :key="item.spSystemId"
          :class="{
            active: selectedAncillaryServiceSystemId == item.spSystemId
          }"
          @click="selectLiveMonitorSystem(item.spSystemId)"
          >{{ item.name }}</span
        >
      </div>
      <div class="ancillary-service-live-monitor-content">
        <el-row class="flex flex-main-justify">
          <el-col :span="3">
            <p class="param-name">Desc</p>
            <p class="param-value">
              {{ descNameObj[modeDescObj[selectedAncillaryServiceSystemId]] }}
            </p>
          </el-col>
          <el-col :span="3">
            <p class="param-name">Target power (kW)</p>
            <p class="param-value">
              {{
                handleDataEmptyShow(ancillaryServiceLiveMonitorData.targetPower)
              }}
            </p>
          </el-col>
          <el-col :span="4">
            <p class="param-name">System power (kW)</p>
            <p class="param-value">
              {{
                handleDataEmptyShow(ancillaryServiceLiveMonitorData.systemPower)
              }}
            </p>
          </el-col>
          <el-col :span="3">
            <p class="param-name">Frequency (Hz)</p>
            <p class="param-value">
              {{
                handleDataEmptyShow(ancillaryServiceLiveMonitorData.frequency)
              }}
            </p>
          </el-col>
          <el-col :span="6" class="flex charge-discharge">
            <div class="charge">
              <p class="param-name">Charging (kWh)</p>
              <p class="param-value">
                {{
                  handleDataEmptyShow(ancillaryServiceLiveMonitorData.charging)
                }}
              </p>
            </div>
            <div class="discharge">
              <p class="param-name">Discharging (kWh)</p>
              <p class="param-value">
                {{
                  handleDataEmptyShow(
                    ancillaryServiceLiveMonitorData.discharging
                  )
                }}
              </p>
            </div>
          </el-col>
          <el-col :span="3">
            <p class="param-name">SOC (%)</p>
            <p class="param-value">
              {{ handleDataEmptyShow(ancillaryServiceLiveMonitorData.soc) }}
            </p>
          </el-col>
        </el-row>
        <div class="real-data-chart" ref="real-data-chart"></div>
      </div>
    </div>
    <!-- system data / asset data -->
    <div
      class="system-asset-data public-box"
      v-show="selectedLevel == 'site' || selectedLevel == 'system'"
    >
      <div class="public-header" v-show="selectedLevel == 'site'">
        <span
          v-for="item in systemAssetDataModeList"
          :key="item.id"
          class=""
          :class="{ active: selectedSystemAssetDataMode == item.id }"
          @click="changeSystemAssetDataMode(item.id)"
          >{{ item.name }}</span
        >
      </div>
      <div class="public-header" v-show="selectedLevel == 'system'">
        <span class="header-title">{{ $t("m.newEnergySystemData") }}</span>
      </div>
      <div class="system-asset-data-content" v-if="selectedLevel == 'site'">
        <!-- system -->
        <div v-if="selectedSystemAssetDataMode == 'system'">
          <el-row>
            <el-col :span="16" class="charging-discharging"
              >{{ $t("m.charging") + " | " + $t("m.discharging") }} (kWh)</el-col
            >
            <el-col :span="8" class="consumption"
              ></el-col
            >
          </el-row>
          <el-row>
            <!-- 系统名字 -->
            <el-col :span="16">
              <el-col
                :span="
                  parseInt(24 / systemChargingDischargingData.systemList.length)
                "
                v-for="(item,
                index) in systemChargingDischargingData.systemList"
                :key="index"
                >{{ item.name }}</el-col
              >
            </el-col>
            <!-- 负荷资产名字 -->
            <el-col :span="8" class="load">{{ $t("m.load") }}</el-col>
          </el-row>
          <el-row>
            <!-- 系统数据 -->
            <el-col :span="16">
              <el-col
                :span="
                  parseInt(24 / systemChargingDischargingData.systemList.length)
                "
                v-for="(item,
                index) in systemChargingDischargingData.systemList"
                :key="index"
                >{{
                  handleDataEmptyShow(item.chargeSum) +
                    " | " +
                    handleDataEmptyShow(item.disChargeSum)
                }}</el-col
              >
            </el-col>
            <!-- 负荷资产数据 -->
            <el-col :span="8" class="load">{{
              handleDataEmptyShow(systemChargingDischargingData.load.loadSum)
            }}</el-col>
          </el-row>
        </div>
        <div v-else>
          <el-row>
            <el-col :span="18" class="charging-discharging"
              >{{ $t("m.consumption") }} (kWh)</el-col
            >
            <el-col :span="6" class="consumption"
              >{{ $t("m.generation") }} (kWh)</el-col
            >
          </el-row>
          <el-row class="asset-data-content">
            <el-col :span="6">{{ $t("m.totalCharging") }}</el-col>
            <el-col :span="6" :offset="haveBESS() ? 0 : 6">{{ $t("m.load") }}</el-col>
            <el-col :span="6" v-if="haveBESS()">{{
              $t("m.batteryCharging")
            }}</el-col>
            <el-col :span="3">{{ $t("m.solar") }}</el-col>
            <el-col :span="3" v-if="haveBESS()">{{
              $t("m.batteryDischarging")
            }}</el-col>
          </el-row>
          <el-row class="asset-data-content param-value">
            <el-col :span="6">{{
              handleDataEmptyShow(assetChargingDischargingData.CHARGING.sum)
            }}</el-col>
            <el-col :span="6" :offset="haveBESS() ? 0 : 6">{{
              handleDataEmptyShow(assetChargingDischargingData.LOAD.sum)
            }}</el-col>
            <el-col :span="6" v-if="haveBESS()">{{
              handleDataEmptyShow(assetChargingDischargingData.BESS_CHARGE.sum)
            }}</el-col>
            <el-col :span="3">{{
              handleDataEmptyShow(assetChargingDischargingData.SOLAR.sum)
            }}</el-col>
            <el-col :span="3" v-if="haveBESS()">{{
              handleDataEmptyShow(
                assetChargingDischargingData.BESS_DISCHARGE.sum
              )
            }}</el-col>
          </el-row>
        </div>
        <div
          class="charging-discharging-load-chart"
          ref="charging-discharging-load-chart"
        ></div>
      </div>
      <div class="system-asset-data-content" v-if="selectedLevel == 'system'">
        <div>
          <el-row>
            <el-col :span="12" class="charging-discharging"
              >{{ $t("m.consumption") }} (kWh)</el-col
            >
            <el-col :span="12" class="consumption"
              >{{ $t("m.generation") }} (kWh)</el-col
            >
          </el-row>
          <el-row class="asset-data-content">
            <el-col :span="6">{{ $t("m.totalCharging") }}</el-col>
            <el-col :span="6" v-if="haveBESS()">{{
              $t("m.batteryCharging")
            }}</el-col>
            <el-col :span="6" :offset="haveBESS() ? 0 : 6">{{ $t("m.solar") }}</el-col>
            <el-col :span="6" v-if="haveBESS()">{{
              $t("m.batteryDischarging")
            }}</el-col>
          </el-row>
          <el-row class="asset-data-content param-value">
            <el-col :span="6">{{
              handleDataEmptyShow(assetChargingDischargingData.CHARGING.sum)
            }}</el-col>
            <el-col :span="6" v-if="haveBESS()">{{
              handleDataEmptyShow(assetChargingDischargingData.BESS_CHARGE.sum)
            }}</el-col>
            <el-col :span="6" :offset="haveBESS() ? 0 : 6">{{
              handleDataEmptyShow(assetChargingDischargingData.SOLAR.sum)
            }}</el-col>
            <el-col :span="6" v-if="haveBESS()">{{
              handleDataEmptyShow(
                assetChargingDischargingData.BESS_DISCHARGE.sum
              )
            }}</el-col>
          </el-row>
        </div>
        <div
          class="charging-discharging-load-chart"
          ref="charging-discharging-load-chart"
        ></div>
      </div>
    </div>
    <!-- meter -->
    <div class="meter public-box" v-show="selectedLevel == 'site'">
      <div class="public-header">
        <span class="header-title">{{ $t("m.meter") }}</span>
      </div>
      <div class="meter-content">
        <el-select v-model="selectedMeterId" @change="changeMeter">
          <el-option
            v-for="item in meterList"
            :key="item.spMeterId"
            :label="item.meterName"
            :value="item.spMeterId"
          >
          </el-option>
        </el-select>
        <div class="meter-chart" ref="meter-chart"></div>
      </div>
    </div>
    <!-- 充电集 total charge pile -->
    <div
      class="charge-pile-chart-box flex"
      v-show="selectedLevel == 'asset-charging'"
    >
      <div class="total-charge-pie-chart-box public-box">
        <div class="public-header">
          <span class="header-title">{{ $t("m.totalCharge") }}</span>
        </div>
        <div v-if="totalChargeObj.total">
          <div
            class="total-charge-pie-chart"
            ref="total-charge-pie-chart"
          ></div>
          <div class="data-one from-solar">
            <div class="flex flex-main-justify">
              <span class="data-value">{{ totalChargeObj.fromSolar }}kWh</span>
              <span class="data-param">{{ $t("m.fromSolar") }}</span>
            </div>
            <el-progress
              :percentage="totalChargeObj.solarPercent"
              :show-text="false"
            ></el-progress>
          </div>
          <div class="data-one from-battery">
            <div class="flex flex-main-justify">
              <span class="data-value"
                >{{ totalChargeObj.fromBattery }}kWh</span
              >
              <span class="data-param">{{ $t("m.fromBattery") }}</span>
            </div>
            <el-progress
              :percentage="totalChargeObj.batteryPercent"
              :show-text="false"
            ></el-progress>
          </div>
          <div class="data-one from-grid">
            <div class="flex flex-main-justify">
              <span class="data-value">{{ totalChargeObj.fromGrid }}kWh</span>
              <span class="data-param">{{ $t("m.fromGrid") }}</span>
            </div>
            <el-progress
              :percentage="totalChargeObj.gridPercent"
              :show-text="false"
            ></el-progress>
          </div>
        </div>
        <div v-else class="empty-box"></div>
      </div>
      <div class="total-charge-line-chart-box public-box">
        <div class="public-header">
          <span class="header-title">{{ $t("m.hourlyCharge") }}</span>
        </div>
        <div
          class="total-charge-line-chart"
          ref="total-charge-line-chart"
        ></div>
      </div>
    </div>
    <!-- 储能 -->
    <div v-show="selectedLevel == 'asset-bess'">
      <div class="charge-discharge-box public-box">
        <div class="public-header flex flex-cross-center flex-main-justify">
          <span class="header-title">{{
            $t("m.hourlyBattery") + " " + $t("m.charging") + " | " + $t("m.discharging")
          }}</span>
          <div class="flex">
            <div>
              <span class="chart-cycle bess-charging"></span>
              <span class="name">{{
                $t("m.batteryCharging")
              }}</span>
            </div>
            <div>
              <span class="chart-cycle bess-discharging"></span>
              <span class="name">{{
                $t("m.batteryDischarging")
              }}</span>
            </div>
          </div>
        </div>
        <div class="charge-discharge-chart" ref="charge-discharge-chart"></div>
      </div>
      <div class="soc-box public-box">
        <div class="public-header">
          <span class="header-title">{{ $t("m.soc") }}</span>
        </div>
        <div class="soc-chart" ref="soc-chart"></div>
      </div>
    </div>
    <!-- 负荷 || 光伏 -->
    <div v-show="selectedLevel == 'load' || selectedLevel == 'asset-pv'">
      <div class="site-load-box public-box" v-show="selectedLevel == 'load'">
        <div class="public-header flex flex-cross-center flex-main-justify">
          <span class="header-title">{{ $t("m.siteLoad") }}</span>
        </div>
        <div class="site-load-chart" ref="site-load-chart"></div>
      </div>
      <div
        class="solar-power-box public-box"
        v-show="selectedLevel == 'asset-pv'"
      >
        <div class="public-header">
          <span class="header-title">{{ $t("m.solarPower") }}</span>
        </div>
        <div class="solar-power-chart" ref="solar-power-chart"></div>
      </div>
      <div class="weather-data-box public-box">
        <div class="public-header flex flex-cross-center flex-main-justify">
          <span class="header-title">{{ $t("m.weatherData") }}</span>
        </div>
        <div class="weather-data-chart" ref="weather-data-chart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import timezoneData from "../assets/data/timezone";
// 各资产充电/放电图的颜色
const chartColorObj = {
  pv: {
    actual: ["#FFB200", "#FFC133", "#FFD166", "#FFE099", "#FFF0CC"],
    forecast: ["#FFE8B2", "#FFECC1", "#FFF1D1", "#FFE099", "#FFFBF0"]
  },
  charging: {
    actual: [
      "#66D1CB",
      "#00B2A9",
      "#66C9EC",
      "#00A5DF",
      "#FFD166",
      "#FFB202",
      "#C2C2C2",
      "#999999"
    ],
    forecast: ["#D7F0EE", "#C1E9F7", "#D1EFF9", "#E0F4FB", "#F0FAFE"]
  },
  batteryCharging: {
    actual: ["#00A5DF", "#33B7E5", "#66C9EC", "#99DBF2", "#CCEDF9"],
    forecast: ["#B2E4F5", "#C1E9F7", "#D1EFF9", "#E0F4FB", "#F0FAFE"]
  },
  batteryDischarging: {
    actual: ["#FF9500", "#FFB200", "#FFC133", "#FFD166", "#FFE099"],
    forecast: ["#FFDFB2", "#FFE8B2", "#FFECC1", "#FFF1D1", "#FFE099"]
  },
  load: {
    actual: ["#999999"],
    forecast: ["#EEEEEE"]
  },
  tariff: {
    import: "#00A5DF",
    export: "#FFB200",
    charger: "#00B2A9",
    mpan: "#999999",
    volume: "#00A5DF"
  },
  SOC: "#27D3D5"
};
export default {
  data() {
    return {
      chartResizeTimer: null,
      firstIn: true,
      eventsTypeTextObj: {
        10: "Ultra Fast Charging",
        20: "Ancillary Service"
      },
      descNameObj: {
        10: "FFR",
        20: "AFFR"
      },
      systemCurrentModeObj: {},
      modeDescObj: {},
      tempDesc: {},
      tempMode: "",
      currentModeStartTime: "",
      currentMode: "10", // 10:ultraFastCharging 20:AncillaryService 30:energySaving 1020:ultraFastCharging && AncillaryService 2030:AncillaryService && energySaving 1030:ultraFastCharging && energySaving 102030 ultraFastCharging && AncillaryService && energySaving
      dateMode: "10", // 同上
      currentModeInterval: null,
      getGunStatusInterval: null,
      gunStatusObj: {},
      gunStatusTextObj: {
        "0": "free",
        "1": "charging",
        "2": "charging",
        "3": "faulted",
        "4": "faulted",
        "5": "charging",
        "6": "reserved",
        "7": "offline",
        "8": "faulted"
      },
      systemId: "",
      haveAncillaryService: false,
      haveEnergySaving: false,
      haveUltraFastCharging: false,
      SOCData: [],
      MPANVolumeList: [],
      MPANPriceList: [],
      predictCharts: null,
      actualData: {},
      actualDataDateArr: [],
      systemChargingDischargingData: {
        load: {},
        systemList: []
      },
      assetChargingDischargingData: {
        CHARGING: {},
        LOAD: {},
        BESS_CHARGE: {},
        SOLAR: {},
        BESS_DISCHARGE: {}
      },
      axisLableColor: "#999",
      selectedSystemAssetDataMode: "system",
      systemAssetDataModeList: [
        {
          id: "system",
          name: this.$t("m.newEnergySystemData")
        },
        {
          id: "asset",
          name: this.$t("m.assetData")
        }
      ],
      topParamInfoData: {
        chargingRevenue: 0,
        charge: {
          total: 0,
          list: [
            {
              name: "From solar",
              value: 0,
              type: "solar"
            },
            {
              name: "From battery",
              value: 0,
              type: "battery"
            },
            {
              name: "From grid",
              value: 0,
              type: "grid"
            }
          ]
        },
        availableCharge: 0,
        utilizationRate: 0
      },
      topInfoData: {
        BESS_CHARGE: {},
        BESS_DISCHARGE: {},
        SOLAR: {},
        LOAD: {}
      },
      planModeClass: {
        10: "ultraFastCharging",
        20: "AncillaryService",
        30: "energySaving"
      },
      systemPlanList: [],
      planTimeList: [
        "00:00",
        "01:00",
        "02:00",
        "03:00",
        "04:00",
        "05:00",
        "06:00",
        "07:00",
        "08:00",
        "09:00",
        "10:00",
        "11:00",
        "12:00",
        "13:00",
        "14:00",
        "15:00",
        "16:00",
        "17:00",
        "18:00",
        "19:00",
        "20:00",
        "21:00",
        "22:00",
        "23:00"
      ],
      meterList: [],
      selectedMeterId: "",
      selectedMeterDetail: {},
      totalChargeChart: null,
      chargingDischargingLoadChart: null,
      meterChart: null,
      chargePileChargePieChart: null,
      chargePileChargeLineChart: null,
      chargeDischargeChart: null,
      SOCChart: null,
      solarPowerChart: null,
      weatherDataChart: null,
      siteLoadChart: null,
      xAxis: {
        type: "time",
        boundaryGap: false,
        // splitNumber: 24,
        splitLine: {
          lineStyle: {
            color: "rgba(207, 212, 221, 0.2)"
          },
          show: true
        },
        axisLine: {
          lineStyle: {
            color: "rgba(207, 212, 221, 0.2)",
            show: true
          }
        },
        axisLabel: {
          formatter: (value, index) => {
            return this.$dayjs(value).format("HH:mm");
          },
          textStyle: {
            color: "#999"
          }
        },
        axisTick: {
          show: false
        },
        minInterval: 1000 * 60 * 60,
        maxInterval: 1000 * 60 * 60 * 2
      },
      totalChargeObj: {},
      weatherData: {
        uvi: [],
        temp: [],
        clouds: []
      },
      chartsUnitObj: {},
      ancillaryServiceLiveMonitorWs: null,
      ancillaryServiceLiveMonitorData: {
        desc: "",
        targetPower: "",
        systemPower: "",
        frequency: "",
        charging: "",
        discharging: "",
        soc: "",
        chargingMin: "",
        dischargingMin: "",
        systemPowerList: [],
        targetPowerList: [],
        frequencyList: [],
        batteryPowerList: []
      },
      realDataChart: null,
      realDataChartOption: null,
      systemWsObj: {},
      systemWsUrlObj: {},
      systemWsTokenObj: {},
      systemEntityIdObj: {},
      systemList: [],
      ancillaryServiceSystemList: [],
      systemChargeGunObj: {},
      systemChargeGunList: [],
      systemChargeGunListObj: {},
      systemBatteryObj: {},
      systemGridObj: {},
      systemLoadObj: {},
      systemSystemObj: {},
      systemSolarObj: {},
      selectedAncillaryServiceSystemId: "",
      chargeChartTimeList: [],
    };
  },
  props: [
    "selectedAssetDetail",
    "selectedSiteInfo",
    "selectedCalendarDate",
    "selectedLevel",
    "planList",
    "realTime"
  ],
  watch: {
    selectedLevel(now) {
      console.log(now, "selectedLevel now");
      console.log(this.selectedAssetDetail, "selectedAssetDetail");
      // this.handleLevelOrDateChange();
    },
    selectedCalendarDate(now, prev) {
      console.log(now, "selectedCalendarDate now");
      console.log(prev, "selectedCalendarDate prev");
      console.log(timezoneData[this.selectedSiteInfo.timeZoneId][now], "timezone data");
      this.handleTimeList(timezoneData[this.selectedSiteInfo.timeZoneId][now]);
      // 当打开dashboard页面之前是其他日期时，会切换到今天，触发当前逻辑，重复调用接口，需要禁止
      if (this.firstIn) {
        this.firstIn = false;
        return;
      }
      this.handleLevelOrDateChange();
    },
    planList(now) {
      console.log(now, "planList now");
      console.log(this.selectedAssetDetail, "selectedAssetDetail");
      this.handleLevelOrDateChange();
    }
  },
  mounted() {
    console.log(this.planList, "planList");
    this.systemPlanList = this.planList;
    if (this.selectedLevel == "site") {
      this.systemList = this.selectedAssetDetail.systemList;
    } else {
      this.systemList = [this.selectedAssetDetail];
    }
    console.log(this.systemList, "system list");
    this.selectedAncillaryServiceSystemId = this.systemList[0].spSystemId;
    window.addEventListener("resize", this.chartResize);
  },
  beforeDestroy() {
    console.log(this.ancillaryServiceLiveMonitorWs, "???");
    this.getGunStatusInterval && clearInterval(this.getGunStatusInterval);
    this.currentModeInterval && clearInterval(this.currentModeInterval);
    this.ancillaryServiceLiveMonitorWs &&
      this.ancillaryServiceLiveMonitorWs.close();
    for (let k in this.systemWsObj) {
      this.systemWsObj[k] && this.systemWsObj[k].close();
    }
    window.removeEventListener("resize", this.chartResize);
  },
  methods: {
    handleTimeList() {
      if (timezoneData[this.selectedSiteInfo.timeZoneId]) {
        // 存在对应的时区数据
        const timezoneDataDetail =
          timezoneData[this.selectedSiteInfo.timeZoneId][this.$dayjs(this.selectedCalendarDate).format("YYYY-MM-DD")];
        console.log(timezoneDataDetail, "timezoneDataDetail");
        let timeStr = "";
        this.chargeChartTimeList = [];
        this.planTimeList = [];
        for (let i = 0; i < 24; i++) {
          // 冬令时转夏令时当天，跳过某个小时
          if (
            timezoneDataDetail &&
            timezoneDataDetail.type == "DST" &&
            i == timezoneDataDetail.num - 1
          ) {
            continue;
          }
          timeStr = i < 10 ? "0" + i + ":00" : i + ":00";
          this.planTimeList.push(timeStr);
          this.chargeChartTimeList.push(this.$dayjs(this.selectedCalendarDate).format("YYYY-MM-DD") + " " + timeStr);
          // 夏令时转冬令时当天，重复某个小时
          if (
            timezoneDataDetail &&
            timezoneDataDetail.type == "ST" &&
            i == timezoneDataDetail.num
          ) {
            this.planTimeList.push(timeStr);
            this.chargeChartTimeList.push(this.$dayjs(this.selectedCalendarDate).format("YYYY-MM-DD") + " " + timeStr);
          }
        }
      }
      this.chargeChartTimeList.push(this.$dayjs(new Date(this.chargeChartTimeList[this.chargeChartTimeList.length - 1]).getTime() + 3600000).format("YYYY-MM-DD HH:mm"));
      console.log(this.planTimeList, "planTimeList");
      console.log(this.chargeChartTimeList, "chargeChartTimeList");
    },
    haveBESS() {
      return (this.selectedLevel == 'site' && this.selectedAssetDetail.batteryList.length) || (this.selectedLevel == 'system' && this.selectedAssetDetail.assetList.findIndex(item => {
        return item.assetTypeCode == 20
      }) != -1);
    },
    chartResize() {
      this.chartResizeTimer && clearTimeout(this.chartResizeTimer);
      this.chartResizeTimer = setTimeout(() => {
        this.totalChargeChart && this.totalChargeChart.resize();
        this.predictCharts && this.predictCharts.resize();
        this.realDataChart && this.realDataChart.resize();
        this.chartTariff && this.chartTariff.resize();
        this.chargePileChargePieChart && this.chargePileChargePieChart.resize();
        this.siteLoadChart && this.siteLoadChart.resize();
        this.chargePileChargeLineChart && this.chargePileChargeLineChart.resize();
        this.chargePileChargeLineChart && this.chargePileChargeLineChart.resize();
        this.chartsSOC && this.chartsSOC.resize();
        this.weatherDataChart && this.weatherDataChart.resize();
        this.totalChargeChart && this.totalChargeChart.resize();
      }, 600);
    },
    currentTimeLineLeft() {
      let time = this.realTime.split(":");
      // 有2%的padding-right
      return ((Number(Number(time[0]) * 60) + Number(time[1])) / 1440) * 98;
    },
    // 显示当前计划的模式和时间段
    handleEventDetailShow(item, index, plan) {
      if (item.spSystemModeType == "10") {
        if (index == plan.plansInfoList.length - 1) {
          return (
            this.eventsTypeTextObj[item.spSystemModeType] +
            " (" +
            item.timeStart +
            "-" +
            item.timeEnd +
            ")"
          );
        } else {
          return "";
        }
      } else {
        // AncillaryService需要展示desc
        return (
          this.eventsTypeTextObj[item.spSystemModeType] +
          " - " +
          this.descNameObj[item.spSystemModeSonType] +
          " (" +
          item.timeStart +
          "-" +
          item.timeEnd +
          ")"
        );
      }
    },
    // 货币的单位
    getMoneyUnit() {
      return this.selectedSiteInfo.siteUnit || "";
    },
    // 获取枪的状态
    getGunStatus() {
      let param = {
        siteId: this.selectedAssetDetail.spSiteId
      };
      if (this.selectedLevel == "system") {
        param.systemId = this.selectedAssetDetail.spSystemId;
      }
      this.$http
        .post("/base/dashboard/charging/gun/status", param, {
          hideLoading: true
        })
        .then(res => {
          console.log(res, "gun status");
          res.data.forEach(item => {
            this.gunStatusObj[item.gunId] = item.device_status == '0' ? item.status : '7';
          });
        });
    },
    // 当前选择时间是否是今天
    isToday() {
      return (
        this.$dayjs(this.selectedCalendarDate).format("YYYY-MM-DD") ==
        this.$dayjs(Date.now()).format("YYYY-MM-DD")
      );
    },
    // 调频模式下，订阅实时数据
    async ancillaryServiceLiveMonitor() {
      this.ancillaryServiceLiveMonitorData = {
        desc: "",
        targetPower: "",
        systemPower: "",
        frequency: "",
        charging: "",
        discharging: "",
        soc: "",
        chargingMin: "",
        dischargingMin: "",
        systemPowerList: [],
        targetPowerList: [],
        frequencyList: [],
        batteryPowerList: []
      };
      this.$http
        .get(
          "/base/dashboard/system/token",
          {
            systemIds: this.selectedAncillaryServiceSystemId
          },
          {
            hideLoading: true
          }
        )
        .then(res => {
          let data = res.data;
          console.log(data, "token");
          this.ancillaryServiceLiveMonitorWs &&
            this.ancillaryServiceLiveMonitorWs.close();
          setTimeout(() => {
            this.ancillaryServiceLiveMonitorWs = new WebSocket(
              data[this.selectedAncillaryServiceSystemId].url.replace('http', 'ws') +
                "/api/ws/plugins/telemetry?token=" +
                data[this.selectedAncillaryServiceSystemId].token
            );
            this.ancillaryServiceLiveMonitorWs.onopen = () => {
              this.ancillaryServiceLiveMonitorWs.send(
                JSON.stringify({
                  // 实时数据
                  tsSubCmds: [
                    {
                      entityType: "ASSET",
                      entityId: this.systemEntityIdObj[
                        this.selectedAncillaryServiceSystemId
                      ],
                      keys:
                        "BatteryChargeEnergy_FFR,BatteryDischargeEnergy_FFR,BESSPower_FFR,Frequency_FFR,SOC_FFR,System_power_FFR,TargetPower_FFR",
                      cmdId: 3
                    }
                  ],
                  historyCmds: [
                    {
                      entityType: "ASSET",
                      entityId: this.systemEntityIdObj[
                        this.selectedAncillaryServiceSystemId
                      ],
                      keys:
                        "BatteryChargeEnergy_FFR,BatteryDischargeEnergy_FFR",
                      startTs: new Date(this.currentModeStartTime).getTime(),
                      endTs: Date.now(),
                      interval:
                        Date.now() -
                        new Date(this.currentModeStartTime).getTime(),
                      limit: 100,
                      agg: "MIN",
                      cmdId: 1
                    },
                    {
                      entityType: "ASSET",
                      entityId: this.systemEntityIdObj[
                        this.selectedAncillaryServiceSystemId
                      ],
                      keys: "System_power_FFR,TargetPower_FFR,Frequency_FFR,BESSPower_FFR",
                      startTs: Date.now() - 5 * 60 * 1000,
                      endTs: Date.now(),
                      interval: 1000,
                      limit: 100,
                      agg: "AVG",
                      cmdId: 2
                    }
                  ]
                })
              );
            };
            this.ancillaryServiceLiveMonitorWs.onmessage = event => {
              let eventData = JSON.parse(event.data);
              let data = eventData.data;
              console.log(data, "ancillary Service data");
              if (eventData.subscriptionId == 3) {
                // 实时数据
                if (
                  this.ancillaryServiceLiveMonitorData.chargingMin &&
                  data &&
                  data["BatteryChargeEnergy_FFR"] &&
                  data["BatteryChargeEnergy_FFR"][0] &&
                  data["BatteryChargeEnergy_FFR"][0][1]
                ) {
                  this.ancillaryServiceLiveMonitorData.charging =
                    data["BatteryChargeEnergy_FFR"][0][1] -
                    this.ancillaryServiceLiveMonitorData.chargingMin;
                }
                if (
                  this.ancillaryServiceLiveMonitorData.dischargingMin &&
                  data &&
                  data["BatteryDischargeEnergy_FFR"] &&
                  data["BatteryDischargeEnergy_FFR"][0] &&
                  data["BatteryDischargeEnergy_FFR"][0][1]
                ) {
                  this.ancillaryServiceLiveMonitorData.charging =
                    data["BatteryDischargeEnergy_FFR"][0][1] -
                    this.ancillaryServiceLiveMonitorData.dischargingMin;
                }
                if (
                  this.ancillaryServiceLiveMonitorData.systemPowerList.length &&
                  data.System_power_FFR
                ) {
                  this.ancillaryServiceLiveMonitorData.systemPowerList.shift();
                  this.ancillaryServiceLiveMonitorData.systemPowerList.push(
                    data["System_power_FFR"][0]
                  );
                  this.realDataChartOption.series[0].data = this.ancillaryServiceLiveMonitorData.systemPowerList;
                  this.realDataChart.setOption(this.realDataChartOption);
                }
                if (
                  this.ancillaryServiceLiveMonitorData.targetPowerList.length &&
                  data.TargetPower_FFR
                ) {
                  this.ancillaryServiceLiveMonitorData.targetPowerList.shift();
                  this.ancillaryServiceLiveMonitorData.targetPowerList.push(
                    data["TargetPower_FFR"][0]
                  );
                  this.realDataChartOption.series[1].data = this.ancillaryServiceLiveMonitorData.targetPowerList;
                  this.realDataChart.setOption(this.realDataChartOption);
                }
                if (
                  this.ancillaryServiceLiveMonitorData.batteryPowerList.length &&
                  data.BESSPower_FFR
                ) {
                  this.ancillaryServiceLiveMonitorData.batteryPowerList.shift();
                  this.ancillaryServiceLiveMonitorData.batteryPowerList.push(
                    data["BESSPower_FFR"][0]
                  );
                  this.realDataChartOption.series[2].data = this.ancillaryServiceLiveMonitorData.batteryPowerList;
                  this.realDataChart.setOption(this.realDataChartOption);
                }
                if (
                  this.ancillaryServiceLiveMonitorData.frequencyList.length &&
                  data.Frequency_FFR
                ) {
                  this.ancillaryServiceLiveMonitorData.frequencyList.shift();
                  this.ancillaryServiceLiveMonitorData.frequencyList.push(
                    data["Frequency_FFR"][0]
                  );
                  this.realDataChartOption.series[3].data = this.ancillaryServiceLiveMonitorData.frequencyList;
                  this.realDataChart.setOption(this.realDataChartOption);
                }
                this.handleSocketData(data, "Frequency_FFR", "frequency");
                this.handleSocketData(data, "SOC_FFR", "soc");
                this.handleSocketData(data, "System_power_FFR", "systemPower");
                this.handleSocketData(data, "TargetPower_FFR", "targetPower");
              } else if (eventData.subscriptionId == 1) {
                // 充电/放电最小值
                this.handleSocketData(
                  data,
                  "BatteryChargeEnergy_FFR",
                  "chargingMin"
                );
                this.handleSocketData(
                  data,
                  "BatteryDischargeEnergy_FFR",
                  "dischargingMin"
                );
              } else if (eventData.subscriptionId == 2) {
                // 折线图历史值
                this.ancillaryServiceLiveMonitorData.systemPowerList =
                  (data && data["System_power_FFR"]) || [];
                this.ancillaryServiceLiveMonitorData.targetPowerList =
                  (data && data["TargetPower_FFR"]) || [];
                this.ancillaryServiceLiveMonitorData.frequencyList =
                  (data && data["Frequency_FFR"]) || [];
                this.ancillaryServiceLiveMonitorData.batteryPowerList =
                  (data && data["BESSPower_FFR"]) || [];
                this.renderRealDataChart();
              }
              console.log(
                this.ancillaryServiceLiveMonitorData,
                "ancillary Service data"
              );
            };
          }, 1000);
        });
    },
    renderRealDataChart() {
      if (!this.$refs["real-data-chart"]) return;
      this.realDataChart = this.$echarts.init(this.$refs["real-data-chart"]);
      this.realDataChartOption = {
        tooltip: {
          trigger: "axis",
          formatter: params => {
            let result = "";
            console.log(params, "params");
            params = params.filter((item, index) => params.findIndex(obj => obj.seriesName === item.seriesName) === index);
            params.forEach((item, index) => {
              if (index == 0) {
                // 时间
                result =
                  result +
                  "<div class='flex flex-main-justify' style='width:200px;line-height:28px;'><span>Time</span>" +
                  "<span>" +
                  this.$dayjs(
                    this.$utcToZonedTime(
                      item.axisValue,
                      this.selectedSiteInfo.timeZoneId
                    )
                  ).format("HH:mm:ss") +
                  "</span></div>";
              }
              if (item.seriesName == "System Power") {
                // 添加单位
                result =
                  result +
                  "<div class='flex flex-main-justify' style='width:200px;line-height:28px;'><span>Unit</span><span>kW</span></div>";
              }
              if (item.seriesName == "Frequency") {
                // 添加单位
                result =
                  result +
                  "<div class='flex flex-main-justify' style='width:200px;line-height:28px;'><span>Unit</span><span>Hz</span></div>";
              }
              result =
                result +
                "<div class='flex flex-main-justify flex-cross-center' style='width:200px;line-height:28px;'><div><span style='display:inline-block;margin-right:5px;margin-left:5px;border-radius:50%;width:10px;height:10px;background-color:" +
                item.color +
                "'></span>";
              result =
                result +
                "<span>" +
                item.seriesName +
                "</span></div>" +
                "<span>" +
                Number(item.value[1]).toFixed(2) +
                "</span></div>";
            });
            return result;
          }
        },
        grid: {
          left: 60,
          right: 60,
          top: 50,
          bottom: 30
        },
        legend: {
          top: 0,
          right: 20,
          selected: {},
          inactiveColor: "#7c8d9d"
        },
        xAxis: {
          type: "time",
          splitLine: {
            lineStyle: {
              color: "rgba(207, 212, 221, 0.2)"
            },
            show: true
          },
          axisLine: {
            lineStyle: {
              color: "rgba(207, 212, 221, 0.2)",
              show: true
            }
          },
          axisLabel: {
            formatter: value => {
              return this.$dayjs(
                this.$utcToZonedTime(value, this.selectedSiteInfo.timeZoneId)
              ).format("HH:mm:ss");
            },
            textStyle: {
              color: this.axisLableColor
            }
          },
          splitNumber: 10,
          axisTick: {
            show: false,
          }
        },
        yAxis: [
          {
            type: "value",
            name: "kW",
            nameTextStyle: {
              color: this.axisLableColor
            },
            boundaryGap: [0, "100%"],
            splitLine: {
              lineStyle: {
                color: "rgba(207, 212, 221, 0.2)"
              },
              show: true
            },
            axisLine: {
              lineStyle: {
                color: "rgba(207, 212, 221, 0.2)",
                show: true
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: this.axisLableColor
              }
            }
          },
          {
            type: "value",
            name: "Hz",
            min: 49.5,
            max: 50.5,
            interval: 0.2,
            nameTextStyle: {
              color: this.axisLableColor
            },
            boundaryGap: [0, "100%"],
            splitLine: {
              lineStyle: {
                color: "rgba(207, 212, 221, 0.2)"
              },
              show: true
            },
            axisLine: {
              lineStyle: {
                color: "rgba(207, 212, 221, 0.2)",
                show: true
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: this.axisLableColor
              }
            }
          }
        ],
        color: ["#00A5DF", "#999999", "#00b2a9", "#D70B19"],
        series: [
          {
            name: "System Power",
            type: "line",
            showSymbol: false,
            data: this.ancillaryServiceLiveMonitorData.systemPowerList
          },
          {
            name: "Target Power",
            type: "line",
            showSymbol: false,
            data: this.ancillaryServiceLiveMonitorData.targetPowerList
          },
          {
            name: "Battery Power",
            type: "line",
            showSymbol: false,
            data: this.ancillaryServiceLiveMonitorData.batteryPowerList,
          },
          {
            name: "Frequency",
            type: "line",
            showSymbol: false,
            data: this.ancillaryServiceLiveMonitorData.frequencyList,
            yAxisIndex: 1
          }
        ]
      };
      this.realDataChart.setOption(this.realDataChartOption);
    },
    handleSocketData(data, socketParam, param) {
      if (
        data &&
        data[socketParam] &&
        data[socketParam][0] &&
        data[socketParam][0][1]
      ) {
        this.ancillaryServiceLiveMonitorData[param] = Number(
          data[socketParam][0][1]
        ).toFixed(2);
      }
    },
    // 数据为空时提示没有数据
    handleDataEmptyShow(data) {
      return data || data == 0
        ? Number(Number(data).toFixed(2)).toLocaleString()
        : 0; // this.$t("m.emptyDataTip");
    },
    // 订阅按system层级，参数有BatteryPower,PVPower,System_power,Charger1_A_power,Charger1_B_power,Charger2_A_power,Charger2_B_power,ImportExport_power
    // LoadPower,ImportExport_power按第一个system
    // SOC
    // charging 当前时间-当前模式开始时间 maxCharging - minCharging
    // discharging 同上
    // interval 时间间隔
    // agg: max, min
    getSocketToken() {
      console.log(this.systemList, "system list");
      let systemIds = "";
      this.systemChargeGunList = [];
      this.systemChargeGunListObj = {};
      let chargeAssetList = [];
      let chargeGunList = [];
      systemIds = this.systemList.map(item => item.spSystemId).join(",");
      this.systemList.forEach(item => {
        chargeGunList = [];
        this.systemEntityIdObj[item.spSystemId] = item.subscribeSpIotDeviceId;
        chargeAssetList = item.assetList.filter(asset => {
          return asset.spAssetTypeId == "3";
        });
        chargeAssetList.forEach(asset => {
          asset.chargerPileList.forEach(chargePile => {
            chargePile.chargerGunList.forEach(chargeGun => {
              chargeGunList.push(chargeGun);
            });
          });
        });
        this.systemChargeGunListObj[item.spSystemId] = chargeGunList;
      });
      console.log(this.systemChargeGunList, "systemChargeGunList");
      console.log(this.systemChargeGunListObj, "systemChargeGunListObj");
      console.log(systemIds, "systemIds");
      this.$http
        .get("/base/dashboard/system/token", {
          systemIds
        })
        .then(res => {
          console.log(res, "socket token");
          const data = res.data;
          for (let k in data) {
            this.systemWsTokenObj[k] = data[k].token;
            this.systemWsUrlObj[k] = data[k].url;
            this.systemEntityIdObj[k] = data[k].iotDeviceId;
            this.systemSocket(k);
          }
        });
    },
    // 获取各个系统对应的token
    systemSocket(id) {
      console.log(id, "system id");
      console.log(this.systemEntityIdObj[id], "Entity id");
      console.log(this.systemList, "system list");
      // 获取枪的状态
      this.getGunStatus();
      this.getGunStatusInterval && clearInterval(this.getGunStatusInterval);
      this.getGunStatusInterval = setInterval(() => {
        this.getGunStatus();
      }, 60000);
      // 超充模式live monitor
      this.systemWsObj[id] && this.systemWsObj[id].close();
      this.systemWsObj[id] = new WebSocket(
        this.systemWsUrlObj[id].replace('http', 'ws') +
          "/api/ws/plugins/telemetry?token=" +
          this.systemWsTokenObj[id]
      );
      this.systemWsObj[id].onopen = () => {
        this.systemWsObj[id].send(
          JSON.stringify({
            // 实时数据
            tsSubCmds: [
              {
                entityType: "ASSET",
                entityId: this.systemEntityIdObj[id],
                keys:
                  "BatteryPower,PVPower,LoadPower,ImportExport_power,System_power,Charger1_A_power,Charger1_B_power,Charger2_A_power,Charger2_B_power",
                cmdId: 25
              }
            ],
            attrSubCmds: []
          })
        );
      };
      this.systemWsObj[id].onmessage = event => {
        let data = JSON.parse(event.data).data;
        console.log(data, "data");
        console.log(
          this.systemChargeGunListObj[id],
          "this.systemChargeGunListObj"
        );
        if (
          data.Charger1_A_power &&
          this.systemChargeGunListObj[id] &&
          this.systemChargeGunListObj[id][0]
        ) {
          this.systemChargeGunListObj[id][0].value = this.handleDataEmptyShow(
            data.Charger1_A_power[0][1]
          );
        }
        if (
          data.Charger1_B_power &&
          this.systemChargeGunListObj[id] &&
          this.systemChargeGunListObj[id][1]
        ) {
          this.systemChargeGunListObj[id][1].value = this.handleDataEmptyShow(
            data.Charger1_B_power[0][1]
          );
        }
        if (
          data.Charger2_A_power &&
          this.systemChargeGunListObj[id] &&
          this.systemChargeGunListObj[id][2]
        ) {
          this.systemChargeGunListObj[id][2].value = this.handleDataEmptyShow(
            data.Charger2_A_power[0][1]
          );
        }
        if (
          data.Charger2_B_power &&
          this.systemChargeGunListObj[id] &&
          this.systemChargeGunListObj[id][3]
        ) {
          this.systemChargeGunListObj[id][3].value = this.handleDataEmptyShow(
            data.Charger2_B_power[0][1]
          );
        }
        if (data.BatteryPower) {
          this.$set(
            this.systemBatteryObj,
            id,
            this.handleDataEmptyShow(data.BatteryPower[0][1])
          );
        }
        if (data.PVPower) {
          this.$set(
            this.systemSolarObj,
            id,
            this.handleDataEmptyShow(-data.PVPower[0][1])
          );
        }
        if (data.ImportExport_power) {
          this.$set(
            this.systemGridObj,
            id,
            this.handleDataEmptyShow(data.ImportExport_power[0][1])
          );
        }
        if (data.LoadPower) {
          this.$set(
            this.systemLoadObj,
            id,
            this.handleDataEmptyShow(data.LoadPower[0][1])
          );
        }
        if (data.System_power) {
          this.$set(
            this.systemSystemObj,
            id,
            this.handleDataEmptyShow(data.System_power[0][1])
          );
        }
        // console.log(this.systemChargeGunListObj[id], "systemChargeGunListObj");
        // console.log(this.systemBatteryObj[id], "systemBatteryObj");
        // console.log(this.systemSolarObj[id], "systemSolarObj");
        // console.log(this.systemGridObj[id], "ImportExport_power");
        // console.log(this.systemLoadObj[id], "LoadPower");
        // console.log(this.systemSystemObj[id], "System_power");
      };
    },
    // 储能资产SOC数据
    getSOCData() {
      this.$http
        .post("/base/dashboard/soc", {
          assetId: this.selectedAssetDetail.spAssetId,
          date: this.$dayjs(this.selectedCalendarDate).format("YYYY-MM-DD")
        })
        .then(res => {
          console.log(res, "soc data");
          this.SOCData = res.data || [];
          this.renderSOCChart();
        });
    },
    // 判断当前时间是否到计划时间
    isFutureTime(time) {
      return false;
    },
    selectLiveMonitorSystem(id) {
      this.selectedAncillaryServiceSystemId = id;
    },
    handleSiteLevel() {
      this.getSiteLevelSystemChargingDischargingData();
      this.renderTotalChargeChart();
      this.getTotalChargeData();
      this.getTotalChargeRevenueData();
      this.getAvailableChargeData();
      this.getSocketToken();
    },
    // 判断系统历史日期一天的模式
    judgeSystemHistoryDateMode() {
      this.dateMode = ""; // 默认为ultraFastCharging
      this.haveUltraFastCharging = false;
      this.haveAncillaryService = false;
      this.haveEnergySaving = false;
      const planList = this.selectedLevel == 'site' ? this.planList : this.systemPlanList;
      planList.forEach(item => {
        console.log(item, "plan one");
        item.plansInfoList[0].infoList.forEach(ele => {
          if (ele.modeType == "10") {
            this.haveUltraFastCharging = true;
          } else if (ele.modeType == "20") {
            this.haveAncillaryService = true;
          } else if (ele.modeType == "30") {
            this.haveEnergySaving = true;
          }
        });
      });
      if (this.haveUltraFastCharging) {
        this.dateMode = "10";
      }
      if (this.haveAncillaryService) {
        this.dateMode += "20";
      }
      if (this.haveEnergySaving) {
        this.dateMode += "30";
      }
      console.log(this.dateMode, 'date mode');
    },
    // 按时查询当前所有系统所处模式
    handleJudgeSystemCurrentMode() {
      this.judgeSystemCurrentMode();
      this.currentModeInterval && clearInterval(this.currentModeInterval);
      this.currentModeInterval = setInterval(() => {
        this.judgeSystemCurrentMode();
      }, 60000);
    },
    // 判断当前系统所属模式
    judgeSystemCurrentMode() {
      console.log(this.systemPlanList, "systemPlanList ????");
      this.systemCurrentModeObj = {};
      this.ancillaryServiceSystemList = [];
      this.systemPlanList.forEach(item => {
        console.log(item, "plan one");
        this.tempMode = "";
        item.plansInfoList[item.plansInfoList.length - 1].infoList.forEach(
          ele => {
            if (
              new Date(
                this.selectedCalendarDate + " " + ele.timeStart
              ).getTime() <
                this.$utcToZonedTime(
                  Date.now(),
                  this.selectedSiteInfo.timeZoneId
                ) &&
              this.$utcToZonedTime(
                Date.now(),
                this.selectedSiteInfo.timeZoneId
              ) <
                new Date(
                  this.selectedCalendarDate + " " + ele.timeEnd
                ).getTime()
            ) {
              this.tempMode = ele.modeType;
              this.tempDesc = ele.spSystemModeSonType;
              console.log(this.tempMode, "temp mode");
              console.log(this.tempDesc, "temp desc");
              this.currentModeStartTime =
                this.selectedCalendarDate + " " + ele.timeStart;
            }
          }
        );
        this.systemCurrentModeObj[item.systemId] = this.tempMode;
        if (this.tempMode == "20") {
          this.modeDescObj[item.systemId] = this.tempDesc;
          this.ancillaryServiceSystemList.push(
            this.systemList.find(ele => {
              return ele.spSystemId == item.systemId;
            })
          );
        }
        console.log(this.modeDescObj, "modeDescObj");
        console.log(this.systemCurrentModeObj, "system current mode");
      });
      if (this.ancillaryServiceSystemList.length) {
        this.selectedAncillaryServiceSystemId = this.ancillaryServiceSystemList[0].spSystemId;
      }
      this.currentMode = ""; // 默认为ultraFastCharging
      this.haveUltraFastCharging = false;
      this.haveAncillaryService = false;
      this.haveEnergySaving = false;
      for (this.systemId in this.systemCurrentModeObj) {
        if (this.systemCurrentModeObj[this.systemId] == 10) {
          this.haveUltraFastCharging = true;
        }
        if (this.systemCurrentModeObj[this.systemId] == 20) {
          this.haveAncillaryService = true;
        }
        if (this.systemCurrentModeObj[this.systemId] == 30) {
          this.haveEnergySaving = true;
        }
      }
      if (this.haveUltraFastCharging) {
        this.currentMode = "10";
      }
      if (this.haveAncillaryService) {
        this.currentMode += "20";
      }
      if (this.haveEnergySaving) {
        this.currentMode += "30";
      }
      console.log(this.currentMode, "current mode");
      if (this.currentMode.includes("20") && ['system', 'site'].includes(this.selectedLevel)) {
        // ancillaryService模式需要开启订阅
        this.ancillaryServiceLiveMonitor();
      } else {
        this.ancillaryServiceLiveMonitorWs &&
          this.ancillaryServiceLiveMonitorWs.close();
      }
    },
    // 资产层级变化/日期变化
    handleLevelOrDateChange() {
      console.log(this.selectedLevel, "level");
      if (this.selectedLevel == "site") {
        this.systemList = this.selectedAssetDetail.systemList;
        // this.selectedAncillaryServiceSystemId = this.systemList[0].spSystemId;
        this.systemPlanList = this.planList;
        this.selectedSystemAssetDataMode = "system";
        this.getSiteMeterList();
        // 选中日期为今天，需要实时判断
        if (this.isToday()) {
          // 按固定频率查询当前所有系统所处模式
          this.handleJudgeSystemCurrentMode();
        } else {
          this.currentModeInterval && clearInterval(this.currentModeInterval);
          this.ancillaryServiceLiveMonitorWs &&
            this.ancillaryServiceLiveMonitorWs.close();
          this.realDataChart = null;
        }
        this.judgeSystemHistoryDateMode();
        this.$nextTick(() => {
          this.handleSiteLevel();
        });
      } else {
        if (this.selectedLevel == "load") {
          this.ancillaryServiceLiveMonitorWs &&
            this.ancillaryServiceLiveMonitorWs.close();
          this.$nextTick(() => {
            this.chartsUnitObj[this.$t("m.weatherTemperature")] = "℃";
            this.getWeatherData("temp");
          });
        } else {
          this.systemPlanList = this.planList.filter(item => {
            return item.systemId == this.selectedAssetDetail.spSystemId;
          });
          this.systemList = [this.selectedAssetDetail];
          this.selectedAncillaryServiceSystemId = this.systemList[0].spSystemId;
          // 按时查询当前所有系统所处模式
          this.handleJudgeSystemCurrentMode();
          if (this.selectedLevel == "system") {
            this.selectedSystemAssetDataMode = "asset";
            this.getSocketToken();
            this.getTotalChargeData();
            this.judgeSystemHistoryDateMode();
          } else if (this.selectedLevel == "asset-charging") {
            this.$nextTick(() => {
              this.getTotalChargeData();
            });
          } else if (this.selectedLevel == "asset-bess") {
            console.log(this.systemPlanList, "systemPlanList");
            this.ancillaryServiceLiveMonitorWs &&
              this.ancillaryServiceLiveMonitorWs.close();
            this.$nextTick(() => {
              this.getSOCData();
            });
          } else if (this.selectedLevel == "asset-pv") {
            this.ancillaryServiceLiveMonitorWs &&
              this.ancillaryServiceLiveMonitorWs.close();
            this.$nextTick(() => {
              this.chartsUnitObj[this.$t("m.globalRadiation")] = "Wh/㎡";
              this.chartsUnitObj[this.$t("m.cloud")] = "";
              this.getWeatherData("clouds");
              this.getWeatherData("uvi");
            });
          }
        }
        this.$nextTick(() => {
          this.getSiteLevelAssetChargingDischargingData();
        });
      }
    },
    // 顶部total charge数据
    getTotalChargeData() {
      let param = {
        date: this.$dayjs(this.selectedCalendarDate).format("YYYY-MM-DD"),
        siteId: this.selectedAssetDetail.spSiteId
      };
      if (this.selectedLevel == "asset-charging") {
        param.assetId = this.selectedAssetDetail.spAssetId;
      }
      this.$http.post("/base/dashboard/charging/sector", param).then(res => {
        console.log(res, "total charge");
        let data = res.data;
        console.log(data, "data");
        console.log(typeof data, "type");
        if (typeof data != "object" || data == null) {
          this.topParamInfoData = {
            chargingRevenue: 0,
            charge: {
              total: 0,
              list: [
                {
                  name: "From solar",
                  value: 0,
                  type: "solar"
                },
                {
                  name: "From battery",
                  value: 0,
                  type: "battery"
                },
                {
                  name: "From grid",
                  value: 0,
                  type: "grid"
                }
              ]
            },
            availableCharge: 0,
            utilizationRate: 0,
            total: 0
          };
          this.$nextTick(() => {
            this.renderTotalChargeChart();
          });
          return;
        }
        let total = 0;
        for (let k in data) {
          data[k] = Number(data[k]).toFixed(2);
          total += Number(data[k]);
        }
        if (this.selectedLevel == "asset-charging") {
          console.log(total, "total");
          let gridPercent = Number(((data.fromGrid * 100) / total).toFixed(2));
          let batteryPercent = Number(
            ((data.fromBattery * 100) / total).toFixed(2)
          );
          let solarPercent = Number(
            ((data.fromSolar * 100) / total).toFixed(2)
          );
          total = Number(total).toFixed(2);
          this.totalChargeObj = {
            ...res.data,
            total,
            gridPercent,
            batteryPercent,
            solarPercent
          };
          this.$nextTick(() => {
            this.renderTotalChargePieChart();
          });
        } else {
          // 站点
          total = Number(total).toFixed(2);
          this.topParamInfoData.charge = {
            total,
            list: [
              {
                name: this.$t("m.fromSolar"),
                value: data.fromSolar
              },
              {
                name: this.$t("m.fromBattery"),
                value: data.fromBattery
              },
              {
                name: this.$t("m.fromGrid"),
                value: data.fromGrid
              }
            ]
          };
          this.$nextTick(() => {
            this.renderTotalChargeChart();
          });
        }
      });
    },
    // 顶部total charge revenue数据
    getTotalChargeRevenueData() {
      this.$http
        .post("/base/dashboard/charging/totalRevenue", {
          date: this.$dayjs(this.selectedCalendarDate).format("YYYY-MM-DD"),
          siteId: this.selectedAssetDetail.spSiteId
        })
        .then(res => {
          console.log(res, "total charge revenue");
          this.topParamInfoData.chargingRevenue = res.data;
        });
    },
    // 顶部available charge数据
    getAvailableChargeData() {
      this.$http
        .post("/base/dashboard/charging/totalAndRate", {
          date: this.$dayjs(this.selectedCalendarDate).format("YYYY-MM-DD"),
          siteId: this.selectedAssetDetail.spSiteId
        })
        .then(res => {
          console.log(res, "available charge");
          if (res.data) {
            this.topParamInfoData.availableCharge = res.data.totalAvailable;
            this.topParamInfoData.utilizationRate = res.data.rate;
          } else {
            this.topParamInfoData.availableCharge = 0;
            this.topParamInfoData.utilizationRate = 0;
          }
        });
    },
    changeMeter(val) {
      this.selectedMeterDetail =
        this.meterList.find(item => {
          return item.spMeterId == val;
        }) || {};
      this.getMeterTariff();
    },
    // meter图
    renderMeterChart() {
      if (!this.$refs["meter-chart"]) return;
      this.chartTariff = null;
      this.chartTariff = this.$echarts.init(this.$refs["meter-chart"]);
      this.tariffOption = {
        grid: {
          left: 60,
          right: 60,
          top: 50,
          bottom: 30
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // type: "none"
          },
          formatter: params => {
            // 最后一个点隐藏tooltip
            if (
              new Date(params[0].axisValue).getTime() >
              new Date(
                this.$dayjs(this.selectedCalendarDate).format("YYYY-MM-DD") +
                  " 23:59:59"
              ).getTime()
            ) {
              return;
            }
            let result = "";
            if (this.selectedLevel == "site") {
              // volume的tooltip最后一个点超出处理
              let i1 = 0;
              let i2 = 0;
              i1 = this.handleXData().findIndex(item => {
                return item == params[0].axisValue;
              });
              i2 = params.findIndex(item => {
                return item.seriesName == this.$t("m.volume");
              });
              if (params.length > 1 && i1 >= this.MPANVolumeList.length - 1) {
                params.splice(i2, 1);
              }
            }
            params.forEach((item, index) => {
              if (result.includes(item.seriesName)) {
                return;
              }
              // 最后一个点隐藏tooltip
              if (
                item.axisValue >
                new Date(
                  this.$dayjs(this.selectedCalendarDate).format("YYYY-MM-DD") +
                    " 23:59:59"
                ).getTime()
              ) {
                return;
              }
              if (index == 0) {
                const timeIndex = this.chargeChartTimeList.findIndex(ele => {
                  return ele == this.$dayjs(item.axisValue).format("YYYY-MM-DD HH:mm");
                });
                console.log(this.chargeChartTimeList[timeIndex + 1], "next time");
                // 时间段
                result =
                  result +
                  "<div class='flex flex-main-justify' style='width:200px;line-height:28px;'><span>Period</span>" +
                  "<span>" +
                  this.$dayjs(item.axisValue).format("HH:mm") +
                  "-" +
                  this.$dayjs(this.chargeChartTimeList[timeIndex + 1]).format("HH:mm") +
                  "</span></div>";
              }
              if (item.seriesName == this.$t("m.volume")) {
                // 添加单位
                result =
                  result +
                  "<div class='flex flex-main-justify' style='width:200px;line-height:28px;'><span>Unit</span><span>kWh</span></div>";
              }
              if (item.seriesName == this.$t("m.tariff")) {
                // 添加单位
                result =
                  result +
                  "<div class='flex flex-main-justify' style='width:200px;line-height:28px;'><span>Unit</span><span>" +
                  this.getMoneyUnit() +
                  "/kWh</span></div>";
              }
              result =
                result +
                "<div class='flex flex-main-justify flex-cross-center' style='width:200px;line-height:28px;'><div><span style='display:inline-block;margin-right:5px;margin-left:5px;border-radius:50%;width:10px;height:10px;background-color:" +
                item.color +
                "'></span>";
              result =
                result +
                "<span>" +
                item.seriesName +
                "</span></div>" +
                "<span>" +
                item.value +
                "</span></div>";
            });
            if (this.selectedLevel == "site" && params.length > 1) {
              // 当在站点页面，且Volume和Tariff都有值时，计算乘积展示
              // 添加单位
              result =
                result +
                "<div class='flex flex-main-justify' style='width:200px;line-height:28px;'><span>Unit</span><span>" +
                this.getMoneyUnit() +
                "</span></div>";
              result =
                result +
                "<div class='flex flex-main-justify' style='width:200px;font-weight:bold;line-height:28px;'><span>Estimated Value</span><span>" +
                (params[0].value * params[1].value).toFixed(2) +
                "</span></div>";
            }
            return result;
          }
        },
        xAxis: {
          // type: "time",
          boundaryGap: false,
          // splitNumber: 24,
          type: "category",
          // data: this.handleXData(25),
          data: this.chargeChartTimeList,
          splitLine: {
            lineStyle: {
              color: "rgba(207, 212, 221, 0.2)"
            },
            show: true
          },
          axisLine: {
            lineStyle: {
              color: "rgba(207, 212, 221, 0.2)",
              show: true
            }
          },
          axisLabel: {
            formatter: (value, index) => {
              return this.$dayjs(value).format("HH:mm");
            },
            // padding: [0, 60, 0, 0],
            textStyle: {
              color: this.axisLableColor
            }
          },
          axisTick: {
            show: false
          },
          minInterval: 1000 * 60 * 60,
          maxInterval: 1000 * 60 * 60 * 2
        },
        yAxis: [
          {
            type: "value",
            name: this.getMoneyUnit() + "/kWh",
            nameTextStyle: {
              color: this.axisLableColor
            },
            splitLine: {
              lineStyle: {
                color: "rgba(207, 212, 221, 0.2)"
              },
              show: true
            },
            axisLine: {
              lineStyle: {
                color: "rgba(207, 212, 221, 0.2)",
                show: true
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: this.axisLableColor
              }
            }
          }
        ],
        series: [
          {
            name: this.$t("m.tariff"),
            data: [],
            type: "line"
          },
          {
            name: this.$t("m.volume"),
            data: [],
            type: "line"
          }
        ]
      };
      if (this.selectedLevel == "site") {
        // 站点
        console.log(this.MPANVolumeList, "MPANVolumeList");
        if (this.MPANVolumeList.length) {
          this.tariffOption.series = [
            {
              name: this.$t("m.volume"),
              data: this.MPANVolumeList.map(item => {
                return {
                  value: Number(item.value).toFixed(2),
                  itemStyle: {
                    color: chartColorObj.tariff.volume
                  }
                };
              }),
              yAxisIndex: 1,
              type: "line",
              // type: "bar",
              // barWidth: "101%",
              color: chartColorObj.tariff.volume,
              areaStyle: {
                color: chartColorObj.tariff.volume
              },
              lineStyle: {
                width: 0
              },
              symbol: "none",
              step: "end",
              symbolSize: 0
            }
          ];
          this.tariffOption.yAxis.push({
            type: "value",
            name: "kWh",
            nameTextStyle: {
              color: this.axisLableColor
            },
            splitLine: {
              lineStyle: {
                color: "rgba(207, 212, 221, 0.2)"
              },
              show: true
            },
            axisLine: {
              lineStyle: {
                color: "rgba(207, 212, 221, 0.2)",
                show: true
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: this.axisLableColor
              }
            }
          });
        }
        if (this.MPANPriceList.length) {
          this.tariffOption.series.push({
            name: this.$t("m.tariff"),
            data: this.MPANPriceList.map(item => {
              return {
                value: Number(item).toFixed(2)
              };
            }),
            type: "line",
            color: chartColorObj.tariff.mpan,
            symbol: "none",
            step: "end",
            symbolSize: 0
          });
        } else {
          this.tariffOption.xAxis.min = new Date("2022-01-01 00:00:00");
          this.tariffOption.xAxis.max = new Date("2022-01-01 24:00:00");
          this.tariffOption.xAxis.type = "time";
          this.tariffOption.yAxis[0].min = 0;
          this.tariffOption.yAxis[0].max = 1;
        }
      }
      console.log(this.tariffOption, "tariffOption");
      this.chartTariff.setOption(this.tariffOption, true);
    },
    // 站点层面meter列表
    getSiteMeterList() {
      this.$http
        .get("/base/dashboard/meter/list", {
          siteId: this.selectedAssetDetail.spSiteId
        })
        .then(res => {
          console.log(res, "meter list");
          this.meterList = res.data;
          this.meterList = this.meterList.filter((item, index, self) => {
            return (
              self.findIndex(obj => obj.spMeterId === item.spMeterId) === index
            );
          });
          this.selectedMeterDetail = this.meterList[0] || {};
          this.selectedMeterId = this.selectedMeterDetail.spMeterId;
          this.getMeterTariff();
        });
    },
    // meter电价
    getMeterTariff() {
      this.$http
        .get("/base/dashboard/meter/price", {
          siteId: this.selectedAssetDetail.spSiteId,
          date: this.$dayjs(this.selectedCalendarDate).format("YYYY-MM-DD"),
          meterId: this.selectedMeterId,
          meterTypeCode: this.selectedMeterDetail.meterTypeCode
        })
        .then(res => {
          console.log(res, "meter tariff");
          this.MPANPriceList = res.data || [];
          if (this.MPANPriceList.length) {
            this.MPANPriceList.push(
              this.MPANPriceList[this.MPANPriceList.length - 1]
            );
          }
          this.$http
            .get("/base/dashboard/meter/data", {
              siteId: this.selectedAssetDetail.spSiteId,
              date: this.$dayjs(this.selectedCalendarDate).format("YYYY-MM-DD"),
              meterId: this.selectedMeterId,
              meterTypeCode: this.selectedMeterDetail.meterTypeCode
            })
            .then(res => {
              console.log(res, "meter tariff");
              this.MPANVolumeList = res.data || [];
              if (this.MPANVolumeList.length) {
                this.MPANVolumeList.push(
                  this.MPANVolumeList[this.MPANVolumeList.length - 1]
                );
              }
              this.renderMeterChart();
            });
        });
    },
    // x轴数据
    handleXData(length = 24) {
      let xData = [];
      let startTime = new Date(
        this.$dayjs(this.selectedCalendarDate).format("YYYY-MM-DD") +
          " 00:00:00"
      ).getTime();
      for (let i = 0; i < length; i++) {
        xData.push(
          this.$dayjs(startTime + i * 3600000).format("YYYY-MM-DD HH:mm:ss")
        );
      }
      return xData;
    },
    // 充放电图
    renderCharingDischargingLoadChart() {
      this.handleTimeList(timezoneData[this.selectedSiteInfo.timeZoneId][this.$dayjs(this.selectedCalendarDate).format("YYYY-MM-DD")]);
      this.seriesObj = {};
      this.legendObj = {};
      // 站点 || 系统
      let domClass = "charging-discharging-load-chart";
      if (this.selectedLevel == "site") {
        if (this.selectedSystemAssetDataMode == "system") {
          this.handleChargeSeries({
            name: "Appliance Load",
            type: "load",
            color: chartColorObj.load["actual"][0],
            predictAreaColor: chartColorObj.load["forecast"][0]
          });
          this.handleChargeSeries({
            name: "System Charging",
            type: "batteryCharging",
            color: chartColorObj.batteryCharging["actual"][0],
            predictAreaColor: chartColorObj.batteryCharging["forecast"][0]
          });
          this.handleChargeSeries({
            name: "System Discharging",
            type: "batteryDischarging",
            color: chartColorObj.batteryDischarging["actual"][0],
            predictAreaColor: chartColorObj.batteryDischarging["forecast"][0]
          });
        } else {
          this.handleChargeSeries({
            name: "Charging",
            type: "charging",
            color: chartColorObj.charging["actual"][0],
            predictAreaColor: chartColorObj.charging["forecast"][0]
          });
          this.handleChargeSeries({
            name: "Appliance Load",
            type: "load",
            color: chartColorObj.load["actual"][0],
            predictAreaColor: chartColorObj.load["forecast"][0]
          });
          if (this.haveBESS()) {
            this.handleChargeSeries({
              name: "Battery Charging",
              type: "batteryCharging",
              color: chartColorObj.batteryCharging["actual"][0],
              predictAreaColor: chartColorObj.batteryCharging["forecast"][0]
            });
          }
          this.handleChargeSeries({
            name: "Solar",
            type: "pv",
            color: chartColorObj.pv["actual"][0],
            predictAreaColor: chartColorObj.pv["forecast"][0]
          });
          if (this.haveBESS()) {
            this.handleChargeSeries({
              name: "Battery Discharging",
              type: "batteryDischarging",
              color: chartColorObj.batteryDischarging["actual"][0],
              predictAreaColor: chartColorObj.batteryDischarging["forecast"][0]
            });
          }
        }
      } else if (this.selectedLevel == "system") {
        this.handleChargeSeries({
          name: "Charging",
          type: "charging",
          color: chartColorObj.charging["actual"][0],
          predictAreaColor: chartColorObj.charging["forecast"][0]
        });
        if (this.haveBESS()) {
          this.handleChargeSeries({
            name: "Battery Charging",
            type: "batteryCharging",
            color: chartColorObj.batteryCharging["actual"][0],
            predictAreaColor: chartColorObj.batteryCharging["forecast"][0]
          });
        }
        this.handleChargeSeries({
          name: "Solar",
          type: "pv",
          color: chartColorObj.pv["actual"][0],
          predictAreaColor: chartColorObj.pv["forecast"][0]
        });
        if (this.haveBESS()) {
          this.handleChargeSeries({
            name: "Battery Discharging",
            type: "batteryDischarging",
            color: chartColorObj.batteryDischarging["actual"][0],
            predictAreaColor: chartColorObj.batteryDischarging["forecast"][0]
          });
        }
      } else if (this.selectedLevel == "asset-bess") {
        // 储能
        domClass = "charge-discharge-chart";
        this.handleChargeSeries({
          name: "Battery Charging",
          type: "batteryCharging",
          color: chartColorObj.batteryCharging["actual"][0],
          predictAreaColor: chartColorObj.batteryCharging["forecast"][0]
        });
        this.handleChargeSeries({
          name: "Battery Discharging",
          type: "batteryDischarging",
          color: chartColorObj.batteryDischarging["actual"][0],
          predictAreaColor: chartColorObj.batteryDischarging["forecast"][0]
        });
      } else if (this.selectedLevel == "asset-pv") {
        // 光伏
        domClass = "solar-power-chart";
        this.handleChargeSeries({
          name: "Solar",
          type: "pv",
          color: chartColorObj.pv["actual"][0],
          predictAreaColor: chartColorObj.pv["forecast"][0]
        });
      } else if (this.selectedLevel == "asset-charging") {
        // 充电集
        domClass = "total-charge-line-chart";
        let gunList = [];
        this.topInfoData.pileList.forEach(item => {
          item.gunList.forEach(ele => {
            gunList.push(ele);
          });
        });
        gunList.forEach((item, index) => {
          this.actualData[item.name] = item.data;
          this.handleChargeSeries({
            name: item.name,
            type: "charging",
            color: chartColorObj.charging["actual"][index],
            predictAreaColor: chartColorObj.charging["forecast"][index]
          });
        });
      } else {
        // 负荷
        domClass = "site-load-chart";
        this.handleChargeSeries({
          name: "Appliance Load",
          type: "load",
          color: chartColorObj.load["actual"][0],
          predictAreaColor: chartColorObj.load["forecast"][0]
        });
      }
      this.predictLegend = [];
      this.predictSeries = [];
      for (let k in this.legendObj) {
        this.predictLegend.push(this.legendObj[k]);
      }
      for (let k in this.seriesObj) {
        this.predictSeries.push(...this.seriesObj[k]);
      }
      this.predictCharts = this.$echarts.init(this.$refs[domClass]);
      this.predictOption = {
        grid: {
          left: 60,
          right: 60,
          bottom: 30
        },
        legend: {
          icon: "none",
          top: 10,
          left: -14,
          selected: {},
          inactiveColor: "#7c8d9d",
          data: this.predictLegend
          // selectedMode: false
        },
        xAxis: {
          // data: this.handleXData(),
          // data: this.actualDataDateArr,
          data: this.chargeChartTimeList,
          type: "category",
          // boundaryGap: false,
          // scale: false,
          // splitNumber: 24,
          splitLine: {
            lineStyle: {
              color: "rgba(207, 212, 221, 0.2)"
            },
            show: true
          },
          axisLine: {
            lineStyle: {
              color: "rgba(207, 212, 221, 0.2)",
              show: true
            }
          },
          axisTick: {
            show: false
          },
          min:
            this.$dayjs(this.selectedCalendarDate).format("YYYY-MM-DD") +
            " 00:00:00",
          max:
            this.$dayjs(
              new Date(this.selectedCalendarDate + " 23:59:59").getTime() + 1000
            ).format("YYYY-MM-DD") + " 00:00:00",
          minInterval: 1000 * 60 * 60,
          maxInterval: 1000 * 60 * 60 * 2,
          axisLabel: {
            formatter: (value, index) => {
              return this.$dayjs(value).format("HH:mm");
            },
            padding: [0, 60, 0, 0],
            textStyle: {
              color: this.axisLableColor
            }
          }
        },
        yAxis: {
          type: "value",
          axisPointer: {
            snap: true
          },
          name: "kWh",
          nameTextStyle: {
            color: this.axisLableColor
          },
          splitLine: {
            lineStyle: {
              color: "rgba(207, 212, 221, 0.2)"
            },
            show: true
          },
          axisLine: {
            lineStyle: {
              color: "rgba(207, 212, 221, 0.2)",
              show: true
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: this.axisLableColor
            }
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none"
          },
          formatter: params => {
            let result = "";
            if (
              this.selectedLevel == "site" ||
              this.selectedLevel == "system"
            ) {
              // 最后一个点隐藏tooltip
              if (
                params[0].axisValue >
                new Date(
                  this.$dayjs(this.selectedCalendarDate).format("YYYY-MM-DD") +
                    " 23:59:59"
                ).getTime()
              ) {
                return;
              }
              // 站点
              let consumption = 0;
              let generation = 0;
              let netWorth = 0;
              let consumptionIndex = 0;
              // 计算充放电的和
              params.forEach(item => {
                if (
                  ["Charging", "Battery Charging", "Appliance Load", "System Charging"].includes(
                    item.seriesName
                  )
                ) {
                  consumption = consumption + Number(item.value);
                  consumptionIndex++;
                }
                if (
                  ["Solar", "Battery Discharging", "System Discharging"].includes(item.seriesName)
                ) {
                  generation = generation + Number(item.value);
                }
              });
              consumption = consumption.toFixed(2);
              generation = generation.toFixed(2);
              netWorth = (Number(consumption) + Number(generation)).toFixed(2);
              params.forEach((item, index) => {
                if (result.includes(item.seriesName)) {
                  return;
                }
                if (index == 0) {
                  const timeIndex = this.chargeChartTimeList.findIndex(ele => {
                    return ele == this.$dayjs(item.axisValue).format("YYYY-MM-DD HH:mm");
                  });
                  console.log(this.chargeChartTimeList[timeIndex + 1], "next time");
                  result =
                    result +
                    "<div class='flex flex-main-justify' style='min-width:200px;line-height:28px;'><span>Period</span>" +
                    "<span>" +
                    this.$dayjs(item.axisValue).format("HH:mm") +
                    "-" +
                    this.$dayjs(this.chargeChartTimeList[timeIndex + 1]).format("HH:mm") +
                    "</span></div>";
                  result =
                    result +
                    "<div class='flex flex-main-justify' style='min-width:200px;line-height:28px;'><span>Unit</span><span>kWh</span></div>";
                  result =
                    result +
                    "<div class='flex flex-main-justify' style='min-width:200px;font-weight:bold;line-height:28px;'><span>Consumption</span><span>" +
                    consumption +
                    "</span></div>";
                } else {
                  if (consumptionIndex == index) {
                    result =
                      result +
                      "<div class='flex flex-main-justify' style='min-width:200px;font-weight:bold;line-height:28px;'><span>Generation</span><span>" +
                      generation +
                      "</span></div>";
                  }
                }
                result =
                  result +
                  "<div class='flex flex-main-justify flex-cross-center' style='min-width:200px;line-height:28px;'><div><span style='display:inline-block;margin-right:5px;margin-left:5px;border-radius:50%;width:10px;height:10px;background-color:" +
                  item.color +
                  "'></span>";
                result =
                  result +
                  "<span style='padding-right:20px;'>" +
                  item.seriesName +
                  "</span></div>" +
                  "<span>" +
                  item.value +
                  "</span></div>";
              });
              result =
                result +
                "<div class='flex flex-main-justify' style='min-width:200px;font-weight:bold;line-height:28px;'><span>Net</span><span>" +
                netWorth +
                "</span></div>";
            } else {
              // 资产页面
              if (this.selectedLevel == "asset-bess") {
                // 储能
                // 计算总充电量，放电量
                let charging = 0;
                let discharging = 0;
                let chargingCount = 0;
                params.forEach(item => {
                  if (item.seriesName.includes("Discharging")) {
                    discharging += Number(item.value);
                    chargingCount++;
                  } else {
                    charging += Number(item.value);
                    chargingCount++;
                  }
                });
                charging = charging.toFixed(2);
                discharging = discharging.toFixed(2);
                params.forEach((item, index) => {
                  if (index == 0) {
                    const timeIndex = this.chargeChartTimeList.findIndex(ele => {
                      return ele == this.$dayjs(item.axisValue).format("YYYY-MM-DD HH:mm");
                    });
                    result =
                      result +
                      "<div class='flex flex-main-justify' style='min-width:200px;line-height:28px;'><span>Period</span>" +
                      "<span>" +
                      this.$dayjs(item.axisValue).format("HH:mm") +
                      "-" +
                      this.$dayjs(this.chargeChartTimeList[timeIndex + 1]).format("HH:mm") +
                      "</span></div>";
                    result =
                      result +
                      "<div class='flex flex-main-justify' style='min-width:200px;line-height:28px;'><span>Unit</span><span>kWh</span></div>";
                    result =
                      result +
                      "<div class='flex flex-main-justify' style='min-width:200px;font-weight:bold;line-height:28px;'><span>Charging</span><span>" +
                      charging +
                      "</span></div>";
                  }
                  if (index == chargingCount - 1) {
                    result =
                      result +
                      "<div class='flex flex-main-justify' style='min-width:200px;font-weight:bold;line-height:28px;'><span>Discharging</span><span>" +
                      discharging +
                      "</span></div>";
                  }
                  result =
                    result +
                    "<div class='flex flex-main-justify flex-cross-center' style='min-width:200px;line-height:28px;'><div><span style='display:inline-block;margin-right:5px;margin-left:5px;border-radius:50%;width:10px;height:10px;background-color:" +
                    item.color +
                    "'></span>";
                  result =
                    result +
                    "<span style='padding-right:20px;'>" +
                    item.seriesName +
                    "</span></div>" +
                    "<span>" +
                    item.value +
                    "</span></div>";
                });
              } else {
                params.forEach((item, index) => {
                  if (index == 0) {
                    const timeIndex = this.chargeChartTimeList.findIndex(ele => {
                      return ele == this.$dayjs(item.axisValue).format("YYYY-MM-DD HH:mm");
                    });
                    result =
                      result +
                      "<div class='flex flex-main-justify' style='min-width:200px;line-height:28px;'><span>Period</span>" +
                      "<span>" +
                      this.$dayjs(item.axisValue).format("HH:mm") +
                      "-" +
                      this.$dayjs(this.chargeChartTimeList[timeIndex + 1]).format("HH:mm") +
                      "</span></div>";
                    result =
                      result +
                      "<div class='flex flex-main-justify' style='min-width:200px;line-height:28px;'><span>Unit</span><span>kWh</span></div>";
                  }
                  result =
                    result +
                    "<div class='flex flex-main-justify flex-cross-center' style='min-width:200px;line-height:28px;'><div><span style='display:inline-block;margin-right:5px;margin-left:5px;border-radius:50%;width:10px;height:10px;background-color:" +
                    item.color +
                    "'></span>";
                  result =
                    result +
                    "<span style='padding-right:20px;'>" +
                    item.seriesName +
                    "</span></div>" +
                    "<span>" +
                    item.value +
                    "</span></div>";
                });
              }
            }
            return result;
          }
        },
        series: this.predictSeries
      };
      this.predictDataCount = 0;
      this.predictSeries.forEach(item => {
        if (item.data && !item.data.length) {
          this.predictDataCount++;
        }
      });
      if (this.predictDataCount == this.predictSeries.length) {
        this.predictOption.yAxis.min = 0;
        this.predictOption.yAxis.max = 1;
      }
      console.log(this.predictCharts, "predictCharts");
      console.log(this.predictOption, "predictOption");
      this.predictCharts.setOption(this.predictOption, true);
      // window.removeEventListener("resize", this.chartResize);
      // window.addEventListener("resize", this.chartResize);
    },
    // 充放电图series处理
    handleChargeSeries(
      param = {
        name: "pv",
        type: "pv",
        color: "rgba(249, 203, 61, 1)",
        areaColor: "rgba(249, 203, 61, 1)"
      }
    ) {
      let key = param.type;
      if (this.selectedLevel == "asset-charging") {
        key = param.name;
      }
      if (!this.actualData[key]) {
        this.actualData[key] = [];
      }
      let obj = {
        name: param.name,
        data: this.actualData[key].map(item => {
          return {
            value: Number(item.value).toFixed(2),
            // 根据真实数据/预测数据设置每个柱子的颜色
            itemStyle: {
              color: item.actualFlag == 1 ? param.color : param.areaColor,
              emphasis: {
                // 禁用高亮效果
                opacity: 1, // 高亮状态下不透明
                color: item.actualFlag == 1 ? param.color : param.areaColor
              }
            }
          };
        }),
        barGap: "-100%",
        type: "bar",
        barWidth: "101%",
        emphasis: {
          focus: "series"
        },
        itemStyle: {
          borderWidth: 1,
          borderColor: param.color,
        }
      };
      if (["load", "batteryCharging", "charging"].includes(param.type)) {
        obj.stack = "Consumption";
      }
      if (["batteryDischarging", "pv"].includes(param.type)) {
        obj.stack = "Generation";
      }
      this.actualDataDateArr = this.actualData[key].map(item => {
        return item.dateTime;
      })
      this.seriesObj[key] = [
        {
          ...obj,
          lineStyle: {
            width: 0
          }
        }
      ];
      this.legendObj[key] = {
        name: param.name,
        textStyle: {
          color: param.color
        }
      };
    },
    // 站点层面系统充放电数据
    getSiteLevelSystemChargingDischargingData() {
      this.$http
        .post("/base/dashboard/aggregation/bessLoad", {
          siteId: this.selectedAssetDetail.spSiteId,
          date: this.$dayjs(this.selectedCalendarDate).format("YYYY-MM-DD")
        })
        .then(res => {
          console.log(res, "bessLoad");
          if (res.data && res.data.systemList) {
            res.data.systemList.forEach(item => {
              // 放电的值在Y轴下方
              item.disChargeList.forEach(ele => {
                ele.value = -ele.value;
              });
            });
            this.systemChargingDischargingData = res.data;
            this.actualData[
              "load"
            ] = this.systemChargingDischargingData.load.loadList;
            this.actualData[
              "batteryCharging"
            ] = this.systemChargingDischargingData.systemList[0].chargeList;
            this.actualData[
              "batteryDischarging"
            ] = this.systemChargingDischargingData.systemList[0].disChargeList;
          } else {
            this.actualData["load"] = [];
            this.actualData["batteryCharging"] = [];
            this.actualData["batteryDischarging"] = [];
          }
          this.renderCharingDischargingLoadChart();
        });
    },
    // 站点层面资产充放电数据 || 系统层面充放电数据 || 资产层面充放电数据
    getSiteLevelAssetChargingDischargingData() {
      let param = {
        date: this.$dayjs(this.selectedCalendarDate).format("YYYY-MM-DD"),
        siteId: this.selectedAssetDetail.spSiteId
      };
      if (this.selectedLevel == "system") {
        param.systemId = this.selectedAssetDetail.spSystemId;
      } else if (
        this.selectedLevel.includes("asset") ||
        this.selectedLevel == "load"
      ) {
        param.assetId = this.selectedAssetDetail.spAssetId;
      }
      console.log(param, "param");
      this.$http.post("/base/dashboard/aggregation", param).then(res => {
        console.log(res, "aggregation");
        this.actualData = {};
        let data = res.data;
        if (!data.BESS_CHARGE || !data.BESS_CHARGE.list) {
          data.BESS_CHARGE = { list: [] };
        }
        if (!data.BESS_DISCHARGE || !data.BESS_DISCHARGE.list) {
          data.BESS_DISCHARGE = { list: [] };
        }
        if (!data.SOLAR || !data.SOLAR.list) {
          data.SOLAR = { list: [] };
        }
        if (!data.CHARGING || !data.CHARGING.list) {
          data.CHARGING = { list: [] };
        }
        if (!data.LOAD || !data.LOAD.list) {
          data.LOAD = { list: [] };
        }
        if (this.selectedLevel == "site" || this.selectedLevel == "system") {
          res.data.BESS_DISCHARGE.list.forEach(item => {
            // 放电的值在Y轴下方
            item.value = -item.value;
          });
          res.data.SOLAR.list.forEach(item => {
            // 光伏的值在Y轴下方
            item.value = -item.value;
          });
          this.assetChargingDischargingData = res.data;
          if (this.selectedLevel == "site") {
            this.actualData[
              "load"
            ] = this.assetChargingDischargingData.LOAD.list;
          }
          this.actualData[
            "batteryCharging"
          ] = this.assetChargingDischargingData.BESS_CHARGE.list;
          this.actualData[
            "batteryDischarging"
          ] = this.assetChargingDischargingData.BESS_DISCHARGE.list;
          this.actualData[
            "charging"
          ] = this.assetChargingDischargingData.CHARGING.list;
          this.actualData["pv"] = this.assetChargingDischargingData.SOLAR.list;
        } else if (this.selectedLevel == "asset-bess") {
          // 储能
          res.data.BESS_DISCHARGE.list.forEach(item => {
            // 放电的值在Y轴下方
            item.value = -item.value;
          });
          this.topInfoData = { ...this.topInfoData, ...res.data };
          this.actualData[
            "batteryCharging"
          ] = this.topInfoData.BESS_CHARGE.list;
          this.actualData[
            "batteryDischarging"
          ] = this.topInfoData.BESS_DISCHARGE.list;
        } else if (this.selectedLevel == "asset-pv") {
          // 光伏
          this.topInfoData = { ...this.topInfoData, ...res.data };
          this.actualData["pv"] = this.topInfoData.SOLAR.list;
        } else if (this.selectedLevel == "asset-charging") {
          // 充电集
          this.topInfoData = { ...this.topInfoData, ...res.data };
        } else {
          // 负荷
          this.topInfoData = { ...this.topInfoData, ...res.data };
          this.actualData["load"] = this.topInfoData.LOAD.list;
        }
        console.log(this.actualData, "this.actualData");
        this.renderCharingDischargingLoadChart();
      });
    },
    isHistory() {
      return (
        new Date(this.selectedCalendarDate).getTime() + 1000 * 60 * 60 * 24 <
        new Date().getTime()
      );
    },
    changeSystemAssetDataMode(id) {
      this.selectedSystemAssetDataMode = id;
      if (id == "asset") {
        // 站点层面资产充放电数据
        this.getSiteLevelAssetChargingDischargingData();
      } else {
        // 站点层面系统充放电数据
        this.getSiteLevelSystemChargingDischargingData();
      }
    },
    // 充电集层面总充电饼图
    renderTotalChargePieChart() {
      if (!this.$refs["total-charge-pie-chart"]) return;
      this.chargePileChargePieChart = this.$echarts.init(
        this.$refs["total-charge-pie-chart"]
      );
      const option = {
        tooltip: {
          trigger: "item"
        },
        color: [
          "rgba(255, 178, 0, 1)",
          "rgba(0, 165, 223, 1)",
          "rgba(153, 153, 153, 1)"
        ],
        title: {
          text: this.totalChargeObj.total,
          left: "center",
          top: "40%",
          textStyle: {
            fontSize: 18,
            color: "#111",
            align: "center"
          },
          subtext: "kWh",
          subtextStyle: {
            fontSize: 16,
            color: "#111",
            align: "center"
          }
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center"
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 20,
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: false
            },
            data: [
              {
                value: this.totalChargeObj.fromSolar,
                name: this.$t("m.fromSolar")
              },
              {
                value: this.totalChargeObj.fromBattery,
                name: this.$t("m.fromBattery")
              },
              {
                value: this.totalChargeObj.fromGrid,
                name: this.$t("m.fromGrid")
              }
            ]
          }
        ]
      };
      this.chargePileChargePieChart.setOption(option, true);
    },
    // 储能页面SOC图
    renderSOCChart() {
      if (!this.$refs["soc-chart"]) return;
      this.chartsSOC = this.$echarts.init(this.$refs["soc-chart"]);
      this.forecastSOCOption = {
        grid: {
          left: 60,
          right: 60,
          top: 50,
          bottom: 30
        },
        legend: {
          icon: "none",
          top: 0,
          left: -14,
          data: [
            {
              name: "SOC",
              textStyle: {
                color: "#01CCCD"
              }
            }
          ],
          selected: {},
          inactiveColor: "#7c8d9d"
        },
        tooltip: {
          trigger: "axis",
          formatter: params => {
            let result = "";
            params.forEach((item, index) => {
              if (result.includes(item.seriesName)) {
                return;
              }
              if (index == 0) {
                result += this.$dayjs(item.axisValue).format("HH:mm") + "<br>";
              }
              result +=
                '<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;left:5px;top:' +
                11 +
                "px;background-color:" +
                chartColorObj[item.seriesName] +
                '"></span>';
              result += item.seriesName + ": " + item.data[1] + "%";
            });
            return result;
          }
        },
        xAxis: {
          type: "time",
          boundaryGap: false,
          // splitNumber: 24,
          splitLine: {
            lineStyle: {
              color: "rgba(207, 212, 221, 0.2)"
            },
            show: true
          },
          axisLine: {
            lineStyle: {
              color: "rgba(207, 212, 221, 0.2)",
              show: true
            }
          },
          axisLabel: {
            formatter: (value, index) => {
              return this.$dayjs(value).format("HH:mm");
            },
            textStyle: {
              color: this.axisLableColor
            }
          },
          axisTick: {
            show: false
          },
          minInterval: 1000 * 60 * 60,
          maxInterval: 1000 * 60 * 60 * 2,
          // max: this.$dayjs(new Date(this.selectedDataDay + " 23:59:59").getTime() + 1000).format("YYYY-MM-DD HH:mm:ss")
          max: this.$dayjs(this.selectedCalendarDate + " 24:00:00").format(
            "YYYY-MM-DD HH:mm:ss"
          )
        },
        yAxis: {
          type: "value",
          name: "%",
          nameTextStyle: {
            color: this.axisLableColor
          },
          splitLine: {
            lineStyle: {
              color: "rgba(207, 212, 221, 0.2)"
            },
            show: true
          },
          axisLine: {
            lineStyle: {
              color: "rgba(207, 212, 221, 0.2)",
              show: true
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: this.axisLableColor
            }
          },
          min: 0,
          max: 100
        },
        series: [
          {
            name: "SOC",
            data: [],
            type: "line"
          }
        ]
      };
      if (this.SOCData.length) {
        let actualData = this.SOCData.filter(item => {
          return item.actualFlag == 1;
        }).map(item => {
          return [item.dateTime, Number(item.value).toFixed(2)];
        });
        this.forecastSOCOption.series = [
          {
            name: "SOC",
            data: actualData,
            type: "line",
            areaStyle: {
              color: "rgba(1, 204, 205, 0.75)"
            },
            lineStyle: {
              color: "rgba(1, 204, 205, 1)"
            },
            emphasis: {
              focus: "series"
            },
            symbolSize: 0,
            color: "#52B7E6"
          }
        ];
      } else {
        this.forecastSOCOption.xAxis.min = new Date("2022-01-01 00:00:00");
        this.forecastSOCOption.xAxis.max = new Date("2022-01-01 24:00:00");
      }
      this.chartsSOC.setOption(this.forecastSOCOption, true);
    },
    // 获取天气数据
    getWeatherData(type) {
      this.$http
        .post("/base/dashboard/weather", {
          date: this.$dayjs(this.selectedCalendarDate).format("YYYY-MM-DD"),
          siteId: this.selectedAssetDetail.spSiteId,
          weatherName: type // temp,feels_like,dew_point,wind_speed,wind_deg,pressure,humidity,rain_1h,snow_1h,uvi,clouds,pop,visibility
        })
        .then(res => {
          console.log(res, "weather");
          // 数据测试
          // res.data.splice(2, 1);
          // res.data.splice(2, 0, res.data[2]);
          this.weatherData[type] = res.data;
          this.$nextTick(() => {
            this.renderWeatherDataChart();
          });
        });
    },
    // 光伏页面/负荷页面天气图
    renderWeatherDataChart() {
      if (!this.$refs["weather-data-chart"]) return;
      this.weatherDataChart = this.$echarts.init(
        this.$refs["weather-data-chart"]
      );
      this.forecastSOCOption = {
        grid: {
          left: 60,
          right: 60,
          top: 50,
          bottom: 30
        },
        legend: {
          icon: "none",
          top: 0,
          left: -14,
          data: [
            {
              name: this.$t("m.weatherTemperature"),
              textStyle: {
                color: "#FA6400"
              }
            }
          ],
          selected: {},
          inactiveColor: "#7c8d9d"
        },
        tooltip: {
          trigger: "axis",
          formatter: params => {
            let result = "";
            params.forEach((item, index) => {
              if (index == 0) {
                result += this.$dayjs(item.axisValue).format("HH:mm") + "<br>";
              } else {
                result += "<br>";
              }
              result +=
                '<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;left:5px;top:' +
                11 +
                "px;background-color:" +
                item.color +
                '"></span>';
              result +=
                item.seriesName +
                ": " +
                item.data +
                this.chartsUnitObj[item.seriesName];
            });
            return result;
          }
        },
        xAxis: {
          // type: "time",
          type: "category",
          boundaryGap: false,
          // splitNumber: 24,
          splitLine: {
            lineStyle: {
              color: "rgba(207, 212, 221, 0.2)"
            },
            show: true
          },
          axisLine: {
            lineStyle: {
              color: "rgba(207, 212, 221, 0.2)",
              show: true
            }
          },
          axisLabel: {
            formatter: (value, index) => {
              return this.$dayjs(value).format("HH:mm");
            },
            textStyle: {
              color: this.axisLableColor
            }
          },
          axisTick: {
            show: false
          },
          minInterval: 1000 * 60 * 60,
          maxInterval: 1000 * 60 * 60 * 2
        },
        yAxis: [
          {
            type: "value",
            name: "℃",
            nameTextStyle: {
              color: this.axisLableColor
            },
            splitLine: {
              lineStyle: {
                color: "rgba(207, 212, 221, 0.2)"
              },
              show: true
            },
            axisLine: {
              lineStyle: {
                color: "rgba(207, 212, 221, 0.2)",
                show: true
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: this.axisLableColor
              }
            }
          }
        ],
        series: []
      };
      if (this.selectedLevel == "asset-pv") {
        // 光伏
        this.forecastSOCOption.yAxis[0].name = "";
        this.forecastSOCOption.yAxis[1] = {
          type: "value",
          name: "Wh/㎡",
          nameTextStyle: {
            color: this.axisLableColor
          },
          splitLine: {
            lineStyle: {
              color: "rgba(207, 212, 221, 0.2)"
            },
            show: true
          },
          axisLine: {
            lineStyle: {
              color: "rgba(207, 212, 221, 0.2)",
              show: true
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: this.axisLableColor
            }
          }
        };
        this.forecastSOCOption.yAxis.name = "";
        this.forecastSOCOption.legend.data = [
          {
            name: this.$t("m.cloud"),
            textStyle: {
              color: "#666666"
            }
          },
          {
            name: this.$t("m.globalRadiation"),
            textStyle: {
              color: "#FF9E1B"
            }
          }
        ];
        this.forecastSOCOption.xAxis.data = this.weatherData.clouds.map(item => {
          return item.datetime;
        });
        this.forecastSOCOption.series = [
          {
            name: this.$t("m.cloud"),
            data: this.weatherData.clouds.map(item => {
              return item.value;
            }),
            type: "line",
            emphasis: {
              focus: "series"
            },
            step: "start",
            symbolSize: 0,
            color: "#666666"
          },
          {
            name: this.$t("m.globalRadiation"),
            data: this.weatherData.uvi.map(item => {
              return item.value;
            }),
            type: "line",
            areaStyle: {
              color: "#FF9E1B"
            },
            emphasis: {
              focus: "series"
            },
            step: "start",
            symbolSize: 0,
            color: "#FF9E1B",
            lineStyle: {
              width: 0
            },
            yAxisIndex: 1
          }
        ];
      } else {
        // 负荷
        this.forecastSOCOption.xAxis.data = this.weatherData.temp.map(item => {
          return item.datetime;
        });
        this.forecastSOCOption.series = [
          {
            name: this.$t("m.weatherTemperature"),
            data: this.weatherData.temp.map(item => {
              return item.value;
            }),
            type: "line",
            // areaStyle: {
            //   color: "rgba(102,41,0,0.4)",
            // },
            step: "start",
            symbolSize: 0,
            color: "#FA6400"
          }
        ];
      }
      let dataIsError = true;
      for (let k in this.weatherData) {
        if (this.weatherData[k].length) {
          dataIsError = false;
        }
      }
      if (dataIsError) {
        this.forecastSOCOption.xAxis.min = new Date("2022-01-01 00:00:00");
        this.forecastSOCOption.xAxis.max = new Date("2022-01-01 24:00:00");
        this.forecastSOCOption.yAxis[0].min = 100;
        this.forecastSOCOption.yAxis[0].max = 0;
      }
      console.log(this.forecastSOCOption, "forecastSOCOption");
      this.weatherDataChart.setOption(this.forecastSOCOption, true);
    },
    // 总充电
    renderTotalChargeChart() {
      if (!this.$refs["total-charge-chart"]) return;
      this.totalChargeChart = this.$echarts.init(
        this.$refs["total-charge-chart"]
      );
      const option = {
        tooltip: {
          trigger: "item"
        },
        title: {
          text: this.topParamInfoData.charge.total,
          left: "center",
          bottom: "20%",
          textStyle: {
            fontSize: 14,
            color: "#111",
            align: "center"
          }
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["120%", "70%"],
            center: ["50%", "70%"],
            startAngle: 180,
            endAngle: 360,
            labelLine: {
              show: false
            },
            label: {
              show: false
            },
            color: ["#FFB200", "#00A5DF", "#999999"],
            data: this.topParamInfoData.charge.list
          }
        ]
      };
      this.totalChargeChart.setOption(option, true);
    }
  }
};
</script>

<style lang="scss">
@import "../assets/scss/variables.scss";
.page-dashboard {
  height: calc(100% - 0.4rem);
  width: 100%;
  padding: 0.2rem;
  overflow-y: auto;
  .empty-box {
    font-size: 0.28rem;
    color: #111;
  }
  .plan-list {
    background-color: #fff;
    box-shadow: $boxShadow;
    border-radius: 0.08rem;
    border: 1px solid $borderColor;
    .el-row {
      padding-right: 2%;
      position: relative;
      &.system-one {
        // height: 0.34rem;
        // line-height: 0.34rem;
        width: 100%;
        .system-name {
          padding: 0 0.1rem;
          text-align: right;
        }
        .el-row {
          margin-bottom: 0.1rem;
          &:last-child {
            margin-bottom: 0;
          }
        }
        .current-time-line-box {
          position: absolute;
          content: "";
          height: 100%;
          z-index: 2;
          .current-time-line {
            width: 2px;
            height: 100%;
            background-color: rgba(255, 178, 0, 1);
          }
          span {
            background: #ffb200;
            box-shadow: 0px 1px 8px 0px rgba(255, 178, 0, 0.3);
            border-radius: 8px;
            color: #fff;
            padding: 0.02rem 0.1rem;
            font-size: 0.12rem;
            transform: translate(-50%, -100%);
          }
        }
      }
      .time-col {
        transform: translateX(-50%);
        text-align: center;
      }
      .special-time {
        position: absolute;
        transform: translateX(-50%);
      }
      .grid-content {
        height: 0.1rem;
      }
    }
    .energySaving {
      background-color: #00a5df;
    }
    .ultraFastCharging {
      background-color: #00b2a9;
    }
    .AncillaryService {
      background-color: #999;
    }
  }
  .info-list {
    margin-top: 0.2rem;
    .benefits {
      .info-one {
        width: 100%;
      }
    }
    .info-one {
      box-shadow: $boxShadow;
      border-radius: 0.08rem;
      border: 1px solid $borderColor;

      padding: 0.2rem;
      height: 1.2rem;
      p {
        color: #111;
      }
      .param-name {
        font-size: 0.14rem;
      }
      .param-value {
        font-size: 0.28rem;
      }
      .total-charge-chart {
        width: 50%;
        height: 100%;
      }
      .charge-from-list {
        width: 50%;
        .charge-one-cycle {
          display: inline-block;
          width: 0.06rem;
          height: 0.06rem;
          border-radius: 50%;
          margin-right: 0.06rem;
          &.solar {
            background-color: #ffb200;
          }
          &.battery {
            background-color: #00a5df;
          }
          &.grid {
            background-color: #999999;
          }
        }
        .charge-one-name {
          font-size: 0.14rem;
        }
        .charge-one-name {
          font-size: 0.14rem;
        }
      }
    }
  }
  .public-header {
    padding: 0 0.2rem;
    position: relative;
    height: 0.4rem;
    line-height: 0.4rem;
    border-bottom: 1px solid #eff2f3;
    background-color: #fff;
    border-radius: 0.08rem 0.08rem 0 0;
    &::before {
      content: "";
      width: 0.04rem;
      height: 0.2rem;
      background: linear-gradient(270deg, #00d1f1 0%, #00a5df 100%);
      box-shadow: 2px 0px 4px 0px rgba(0, 168, 228, 0.1);
      border-radius: 0px 2px 2px 0px;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    .header-title {
      color: #111;
    }
    .chart-cycle {
      display: inline-block;
      margin: 0 0.1rem 0 0.4rem;
      width: 0.2rem;
      height: 0.1rem;
      border-radius: 0.04rem;
      &.cycle-1 {
        background-color: #00b2a9;
      }
      &.cycle-2 {
        background-color: #00a5df;
      }
      &.cloud {
        background-color: #aab7bc;
      }
      &.global-radiation {
        background-color: #ff9500;
      }
      &.bess-charging {
        background-color: #00a5df;
      }
      &.bess-discharging {
        background-color: #ff9500;
      }
    }
  }
  .public-box {
    background-color: #fff;
    margin-top: 0.2rem;
    box-shadow: $boxShadow;
    border-radius: 0.08rem;
    border: 1px solid $borderColor;
  }
  .live-monitor {
    .free {
      background-color: #00b2a9;
    }
    .reserved {
      background-color: #fa6400;
    }
    .charging {
      background-color: #ffb200;
    }
    .offline {
      background-color: #cfd8db;
    }
    .faulted {
      background-color: #d70b19;
    }
    .live-monitor-header {
      .status-one {
        margin-left: 0.2rem;
      }
      .status-cycle {
        width: 0.12rem;
        height: 0.08rem;
        display: inline-block;
        margin-right: 0.1rem;
      }
    }
    .live-monitor-content {
      padding: 0.1rem 0.2rem;
      .el-row {
        height: 0.24rem;
        line-height: 0.24rem;
        &:nth-child(2n) {
          background-color: #f9f9f9;
        }
        &:nth-child(2n + 1) {
          background-color: #eff2f3;
        }
        &:first-child {
          background-color: #00a5df;
          .el-col {
            color: #fff;
          }
        }
        .el-col {
          color: #111;
          &.param-name {
            padding-left: 0.2rem;
          }
          &.param-value {
            border-left: 1px solid #fff;
            text-align: center;
          }
          &.system-one {
            border-left: 1px solid #fff;
            height: 100%;
            .param-value {
              height: 100%;
              color: #fff;
            }
          }
        }
      }
    }
  }
  .ancillary-service-live-monitor {
    .public-header {
      span {
        color: #111;
        font-size: 0.16rem;
        margin-right: 0.2rem;
        padding-right: 0.2rem;
        display: inline-block;
        height: 0.4rem;
        cursor: pointer;
        position: relative;
        &.active {
          color: #00a5df;
        }
        &:not(:last-child)::after {
          content: "";
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 2px;
          height: 0.2rem;
          background-color: #ccc;
        }
      }
    }
    .ancillary-service-live-monitor-content {
      .el-row {
        padding: 0.2rem;
      }
      .el-col {
        box-shadow: $boxShadow;
        border-radius: 0.08rem;
        border: 1px solid $borderColor;
        padding: 0.2rem;
        height: 1.2rem;
        p {
          color: #111;
        }
        .param-name {
          font-size: 0.14rem;
          margin-bottom: 0.1rem;
        }
        .param-value {
          font-size: 0.28rem;
        }
        &.charge-discharge {
          .charge {
            width: 46%;
            position: relative;
            &::after {
              content: "";
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 2px;
              height: 70%;
              background-color: #ccc;
            }
          }
          .discharge {
            width: 50%;
            padding-left: 0.2rem;
          }
        }
      }
      .real-data-chart {
        width: 100%;
        height: 2rem;
      }
    }
  }
  .system-asset-data {
    margin-top: 0.2rem;
    background-color: #fff;
    .public-header {
      span {
        color: #111;
        font-size: 0.16rem;
        margin-right: 0.2rem;
        display: inline-block;
        height: 0.4rem;
        cursor: pointer;
        &.active {
          color: #00a5df;
          border-bottom: 1px solid #00a5df;
        }
      }
    }
    .system-asset-data-content {
      padding: 0.1rem 0.2rem;
      .el-row {
        border-bottom: 1px solid #eff2f3;
        // border-right: 1px solid #eff2f3;
        &:first-child {
          border-right: 0;
          border-bottom: 0;
        }
      }
      .charging-discharging {
        background-color: rgba(0, 165, 223, 0.04);
        padding-left: 0.1rem;
      }
      .consumption {
        background-color: rgba(255, 149, 0, 0.04);
        padding-left: 0.1rem;
      }
      .el-col {
        height: 0.4rem;
        line-height: 0.4rem;
        &.load {
          border-left: 1px solid #eff2f3;
          border-right: 1px solid #eff2f3;
          padding-left: 0.1rem;
        }
        .el-col {
          border-left: 1px solid #eff2f3;
          padding-left: 0.1rem;
        }
      }
      .asset-data-content {
        .el-col {
          border-left: 1px solid #eff2f3;
          padding-left: 0.1rem;
          box-sizing: border-box;
        }
        &.param-value {
          color: #111;
        }
      }
      .charging-discharging-load-chart {
        width: 100%;
        height: 2rem;
        margin-top: 0.2rem;
      }
    }
  }
  .meter {
    margin-top: 0.2rem;
    .meter-content {
      padding: 0.1rem 0.2rem;
      .meter-chart {
        width: 100%;
        height: 4rem;
      }
    }
  }
  .charge-pile-chart-box {
    .total-charge-pie-chart-box {
      width: 3rem;
      padding-bottom: 0.2rem;
      height: 4rem;
    }
    .total-charge-line-chart-box {
      flex: 1;
      height: 4rem;
      margin-left: 0.2rem;
      .total-charge-line-chart {
        height: calc(100% - 0.4rem);
        width: 90%;
        margin: 0 auto;
      }
    }
    .total-charge-pie-chart {
      height: 2rem;
      width: 2rem;
      margin: 0 auto;
    }
    .data-one {
      margin-top: 0.1rem;
      padding: 0 0.2rem;
      &.from-solar {
        .el-progress-bar__outer {
          background-color: rgba(255, 178, 0, 0.2);
        }
        .el-progress-bar__inner {
          background-color: rgba(255, 178, 0, 1);
        }
        .data-value {
          color: rgba(255, 178, 0, 1);
        }
      }
      &.from-battery {
        .el-progress-bar__outer {
          background-color: rgba(0, 165, 223, 0.2);
        }
        .el-progress-bar__inner {
          background-color: rgba(0, 165, 223, 1);
        }
        .data-value {
          color: rgba(0, 165, 223, 1);
        }
      }
      &.from-grid {
        .el-progress-bar__outer {
          background-color: rgba(153, 153, 153, 0.2);
        }
        .el-progress-bar__inner {
          background-color: rgba(153, 153, 153, 1);
        }
        .data-value {
          color: rgba(153, 153, 153, 1);
        }
      }
      .data-param {
        color: #999;
      }
    }
    .empty-box {
      text-align: center;
      padding-top: 0.2rem;
      font-size: 0.28rem;
    }
  }
  .charge-discharge-box {
    .charge-discharge-chart {
      height: 4rem;
    }
  }
  .soc-box {
    .soc-chart {
      height: 2rem;
    }
  }
  .solar-power-box {
    .solar-power-chart {
      height: 4rem;
    }
  }
  .weather-data-box {
    .weather-data-chart {
      height: 2rem;
      width: 90%;
      margin: 0 auto;
    }
  }
  .site-load-box {
    .site-load-chart {
      height: 4rem;
    }
  }
}
</style>
